export const AnimalProductSchick = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1997 3.29198V3.29198C16.703 2.44414 13.9563 3.49277 12.6599 5.78877L9.88489 10.7181C9.31244 11.744 9.49286 13.0255 10.3263 13.8534L12.14 15.6725C12.9688 16.5047 14.2502 16.6837 15.2753 16.1103L20.2055 13.3362C22.5014 12.0392 23.5499 9.29245 22.7023 6.79551V6.79551C22.1467 5.14433 20.8507 3.84806 19.1997 3.29198Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.86019 18.9141C9.70182 18.7601 9.52721 18.6237 9.33943 18.5074L12.1581 15.6887L10.3043 13.834L7.48468 16.6527C7.36917 16.4643 7.23276 16.2897 7.07806 16.1319C6.18524 15.1142 4.63922 15.0055 3.61287 15.8885C2.73011 16.9151 2.83829 18.4609 3.85542 19.3546C4.41274 19.9119 5.70661 20.2846 6.16673 19.8245C5.70661 20.2846 6.07756 21.5794 6.63755 22.1358C7.53037 23.1536 9.07639 23.2622 10.1027 22.3792C10.9849 21.3528 10.8767 19.8076 9.86019 18.9141Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AnimalProductsEgg = () => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6224 14.2564C20.9584 13.3825 21.1286 12.4579 21.125 11.5264C21.125 6.14125 17.4872 1.77637 13 1.77637C8.51287 1.77637 4.87504 6.14437 4.87504 11.5264C4.87218 12.4542 5.02696 13.3763 5.33329 14.2564"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 4.49902C9.5 5.49902 8 7.49902 7.62305 8.99902"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1042 25.1759C19.3114 23.442 22.2185 19.6658 22.7103 15.2959C22.746 14.7613 22.4936 14.2559 21.9379 14.2559H4.06287C3.50496 14.2559 3.25471 14.7571 3.29046 15.2959C3.78228 19.6658 6.68937 23.442 10.8965 25.1759"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.25 25.1758H22.75"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AnimalDrumsticks = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 7L13 13M19 19L13 13M13 13L19 7M13 13L7 19"
        stroke="black"
        strokeWidth="1.63"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AthleticsTeamRunning = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2669 7.13425C10.8491 7.13425 9.69973 5.98491 9.69973 4.56713C9.69973 3.14934 10.8491 2 12.2669 2C13.6846 2 14.834 3.14934 14.834 4.56713C14.834 5.98491 13.6846 7.13425 12.2669 7.13425Z"
        stroke="black"
        strokeWidth="1.46693"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64465 6.42845C5.02635 6.35054 5.42336 6.42829 5.74747 6.64442C6.07158 6.86056 6.29595 7.19718 6.37074 7.5795C6.62418 8.86789 7.85867 9.71923 9.15302 9.49824L17.1204 8.356C19.5611 7.96661 21.8932 9.51159 22.4864 11.9109C22.5811 12.2882 22.522 12.6878 22.3221 13.0216C22.1222 13.3554 21.7979 13.5961 21.4205 13.6907C21.3033 13.7197 21.1832 13.7345 21.0625 13.7347C20.3938 13.7299 19.8131 13.2734 19.6504 12.6248C19.4273 11.6857 18.5094 11.0847 17.5595 11.2556L15.6721 11.5265L16.9121 15.8452C17.0463 16.4373 17.5332 16.8844 18.1345 16.9679L21.2777 17.4167C22.0797 17.5315 22.6369 18.2747 22.5221 19.0768C22.4074 19.8789 21.6641 20.436 20.8621 20.3213L17.7189 19.8734C16.1772 19.6609 14.8645 18.6454 14.2716 17.2065L13.6232 17.3923C12.9257 17.5871 12.4776 18.2653 12.5719 18.9834L12.9925 22.3574C13.071 22.8839 12.8581 23.4116 12.4361 23.7363C12.0142 24.0609 11.4495 24.1315 10.9607 23.9207C10.4719 23.7099 10.1356 23.2508 10.0821 22.7212L9.66058 19.3492C9.37797 17.1927 10.7211 15.1558 12.8145 14.566L13.4394 14.388L12.7353 11.949L9.58821 12.3998C6.74577 12.8517 4.05434 10.9765 3.4936 8.15356C3.33537 7.35939 3.85059 6.58721 4.64465 6.42845Z"
        stroke="black"
        strokeWidth="1.46693"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BarbecueStreakShrimp = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.401 13.7319H16.0486C14.5829 10.3738 10.8639 8.61238 7.33714 9.60611C3.81042 10.5998 1.55807 14.0438 2.06131 17.6731C2.56456 21.3024 5.669 24.0036 9.33305 24.0003H17.401C20.2366 24.0003 22.5352 21.7016 22.5352 18.8661C22.5352 16.0306 20.2366 13.7319 17.401 13.7319V13.7319Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4023 16.6663H13.735C13.735 14.2359 11.7648 12.2656 9.33432 12.2656C6.90386 12.2656 4.93359 14.2359 4.93359 16.6663C4.93359 19.0968 6.90386 21.0671 9.33432 21.0671H17.4023C18.6175 21.0671 19.6027 20.0819 19.6027 18.8667C19.6027 17.6515 18.6175 16.6663 17.4023 16.6663Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.23391 15.2012C8.43645 15.2012 8.60064 15.3654 8.60064 15.5679C8.60064 15.7704 8.43645 15.9346 8.23391 15.9346C8.03138 15.9346 7.86719 15.7704 7.86719 15.5679C7.86719 15.3654 8.03138 15.2012 8.23391 15.2012"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8763 6.29039C17.3342 6.49514 17.8635 6.46111 18.2914 6.19944C18.9021 5.8576 19.652 5.88239 20.2388 6.26382C20.8257 6.64526 21.1528 7.32051 21.0883 8.01743C21.0433 8.87215 20.5455 11.0549 22.4574 11.1556C24.0227 9.53944 24.4516 7.13556 23.5419 5.07775C22.8804 3.56642 21.5333 2.4647 19.9208 2.11609C18.3083 1.76747 16.6264 2.21438 15.3996 3.31746C15.0327 3.64559 14.8533 4.13502 14.9214 4.62256C14.9896 5.11011 15.2961 5.53165 15.739 5.74666L16.8763 6.29039Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9814 6.12349L20.6582 2.33398"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0762 7.63477L23.9846 7.78732"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BreadGlutenFree = () => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 20.9028L17.7764 19.1792"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4433 20.8377C14.8869 20.8344 15.3061 20.6347 15.5882 20.2924C15.8703 19.95 15.9862 19.5003 15.9047 19.0643C15.9007 18.6208 15.7006 18.2018 15.3582 17.9199C15.0159 17.6379 14.5663 17.5219 14.1302 17.6029C13.0144 17.7112 10.9658 18.6397 11.0525 19.5334C11.1391 20.4272 13.3242 20.9461 14.4433 20.8377Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3788 16.7733C10.8224 16.7699 11.2417 16.5702 11.5237 16.2279C11.8058 15.8856 11.9217 15.4359 11.8403 14.9998C11.8373 14.5562 11.6377 14.1366 11.2953 13.8545C10.9529 13.5723 10.5029 13.4565 10.0668 13.5384C8.94993 13.6468 6.90135 14.5752 6.98802 15.4678C7.07468 16.3605 9.26302 16.8805 10.3788 16.7733Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4352 15.8439C19.433 16.2887 19.2333 16.7095 18.89 16.9925C18.5468 17.2754 18.0956 17.3912 17.6586 17.3086C17.2151 17.3045 16.7961 17.1044 16.5141 16.7621C16.2321 16.4197 16.1161 15.9701 16.1971 15.5341C16.3055 14.4182 17.2339 12.3697 18.1276 12.4552C19.0214 12.5408 19.5436 14.7302 19.4352 15.8439Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3712 11.7817C15.3679 12.2252 15.1681 12.6445 14.8258 12.9266C14.4835 13.2087 14.0338 13.3246 13.5978 13.2431C13.1536 13.2411 12.7331 13.0419 12.4502 12.6993C12.1673 12.3568 12.0512 11.9063 12.1331 11.4697C12.2415 10.3528 13.1699 8.30418 14.0626 8.39085C14.9552 8.47751 15.4796 10.6648 15.3712 11.7817Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.73208 8.83695C10.0725 9.12141 10.2693 9.5422 10.2693 9.98583C10.2693 10.4295 10.0725 10.8502 9.73208 11.1347C9.44762 11.4751 9.02684 11.6719 8.58321 11.6719C8.13958 11.6719 7.71879 11.4751 7.43433 11.1347C6.64133 10.3417 5.65116 8.31804 6.28491 7.68754C6.91866 7.05704 8.93908 8.04287 9.73208 8.83695Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 26.1743C19.731 26.1743 25.1875 20.7178 25.1875 13.9868C25.1875 7.25585 19.731 1.79932 13 1.79932C6.26903 1.79932 0.8125 7.25585 0.8125 13.9868C0.8125 20.7178 6.26903 26.1743 13 26.1743Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6179 5.36865L18.6875 8.29907"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.38281 22.6026L7.31215 19.6743"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChargeOne = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.73958 10.832L7.73958 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9896 10.832L10.9896 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2396 10.832L14.2396 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4896 10.832L17.4896 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2816 10.832L21.2816 9.7487C21.2816 8.55161 20.312 7.58203 19.1149 7.58203L6.11491 7.58203C4.91782 7.58203 3.94824 8.55161 3.94824 9.7487L3.94824 16.2487C3.94824 17.4458 4.91782 18.4154 6.11491 18.4154L19.1149 18.4154C20.312 18.4154 21.2816 17.4458 21.2816 16.2487L21.2816 15.1654M21.2816 10.832L21.2816 15.1654M21.2816 10.832C21.2816 10.832 23.4482 10.832 23.4482 12.9987C23.4482 15.1654 21.2816 15.1654 21.2816 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChargeTwo = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.73958 10.832L7.73958 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9896 10.832L10.9896 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2396 10.832L14.2396 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2816 10.832L21.2816 9.7487C21.2816 8.55161 20.312 7.58203 19.1149 7.58203L6.11491 7.58203C4.91782 7.58203 3.94824 8.55161 3.94824 9.7487L3.94824 16.2487C3.94824 17.4458 4.91782 18.4154 6.11491 18.4154L19.1149 18.4154C20.312 18.4154 21.2816 17.4458 21.2816 16.2487L21.2816 15.1654M21.2816 10.832L21.2816 15.1654M21.2816 10.832C21.2816 10.832 23.4482 10.832 23.4482 12.9987C23.4482 15.1654 21.2816 15.1654 21.2816 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChargeThree = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.73958 10.832L7.73958 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9896 10.832L10.9896 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2816 10.832L21.2816 9.7487C21.2816 8.55161 20.312 7.58203 19.1149 7.58203L6.11491 7.58203C4.91782 7.58203 3.94824 8.55161 3.94824 9.7487L3.94824 16.2487C3.94824 17.4458 4.91782 18.4154 6.11491 18.4154L19.1149 18.4154C20.312 18.4154 21.2816 17.4458 21.2816 16.2487L21.2816 15.1654M21.2816 10.832L21.2816 15.1654M21.2816 10.832C21.2816 10.832 23.4482 10.832 23.4482 12.9987C23.4482 15.1654 21.2816 15.1654 21.2816 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ChargeFour = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.73958 10.832L7.73958 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2816 10.832L21.2816 9.7487C21.2816 8.55161 20.312 7.58203 19.1149 7.58203L6.11491 7.58203C4.91782 7.58203 3.94824 8.55161 3.94824 9.7487L3.94824 16.2487C3.94824 17.4458 4.91782 18.4154 6.11491 18.4154L19.1149 18.4154C20.312 18.4154 21.2816 17.4458 21.2816 16.2487L21.2816 15.1654M21.2816 10.832L21.2816 15.1654M21.2816 10.832C21.2816 10.832 23.4482 10.832 23.4482 12.9987C23.4482 15.1654 21.2816 15.1654 21.2816 15.1654"
        stroke="#323232"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Close = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 7L13 13M19 19L13 13M13 13L19 7M13 13L7 19"
        stroke="black"
        strokeWidth="1.63"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CoffeColdPressOne = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25034 9.25C2.9472 9.25027 2.67402 9.433 2.55805 9.71308C2.44208 9.99316 2.50612 10.3155 2.72034 10.53L5.00034 12.552C5.31952 12.8375 5.50147 13.2458 5.50034 13.674V22.75C5.50034 23.5784 6.17191 24.25 7.00034 24.25H16.0003C16.8288 24.25 17.5003 23.5784 17.5003 22.75V9.25H3.25034Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25 16.75H13.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 9.25V16.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 9.25C17.124 6.389 14.576 4.75 11.5 4.75C8.424 4.75 5.876 6.389 5.5 9.25H17.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 4.75C12.3284 4.75 13 4.07843 13 3.25C13 2.42157 12.3284 1.75 11.5 1.75C10.6716 1.75 10 2.42157 10 3.25C10 4.07843 10.6716 4.75 11.5 4.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10.75H19C21.4823 10.7571 23.4929 12.7677 23.5 15.25V15.25C23.4929 17.7323 21.4823 19.7429 19 19.75H17.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 21.25H17.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CoffeeCupHot = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.2504 1.75C7.7504 3.25 10.7504 4 9.2504 5.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0004 1.75C11.5004 3.25 14.5004 4 13.0004 5.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7504 1.75C15.2504 3.25 18.2504 4 16.7504 5.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.338 17.5098C21.867 18.1948 23.5 19.2788 23.5 20.4998C23.5 22.5708 18.8 24.2498 13 24.2498C7.2 24.2498 2.5 22.5708 2.5 20.4998C2.5 19.2788 4.133 18.1998 6.661 17.5098"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.24975 11.5C5.49975 16.75 7.43675 19 7.43675 19C7.74975 19.75 9.92775 21.25 12.9998 21.25C16.0718 21.25 18.2498 19.75 18.5628 19C18.5628 19 20.4998 16.75 19.7498 11.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 14.5C16.7279 14.5 19.75 13.1569 19.75 11.5C19.75 9.84315 16.7279 8.5 13 8.5C9.27208 8.5 6.25 9.84315 6.25 11.5C6.25 13.1569 9.27208 14.5 13 14.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99023 13.5096L8.50023 12.9996C9.7611 11.9567 11.3658 11.4218 13.0002 11.4996C14.6347 11.4218 16.2394 11.9567 17.5002 12.9996L18.0102 13.5096"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CoffeeMachineOne = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 23.3207C2.42157 23.3207 1.75 22.676 1.75 21.8807V3.1607C1.75 2.36541 2.42157 1.7207 3.25 1.7207H22.75C23.5784 1.7207 24.25 2.36541 24.25 3.1607V6.0407C24.25 6.83599 23.5784 7.4807 22.75 7.4807H9.25V23.3207H3.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.25 15.4004V21.8804C21.25 22.6757 20.5784 23.3204 19.75 23.3204H15.25C14.4216 23.3204 13.75 22.6757 13.75 21.8804V19.2999C13.7497 18.6294 13.5871 17.9682 13.275 17.3684L12.25 15.4004H14.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 15.4004H22.75C23.5784 15.4004 24.25 16.0451 24.25 16.8404V18.2804"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25 23.3203H24.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.75 1.7207V3.1607C10.75 3.95599 11.4216 4.6007 12.25 4.6007H24.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 6.04102H4.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 8.91992H4.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 11.8008H4.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 12.5206C19 13.3159 18.3284 13.9606 17.5 13.9606C16.6716 13.9606 16 13.3159 16 12.5206C16 11.7257 17.5 9.64062 17.5 9.64062C17.5 9.64062 19 11.7257 19 12.5206Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ColorPalette = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9985 6.90684C12.8338 6.90684 12.7006 7.04009 12.7027 7.20475C12.7027 7.36942 12.836 7.50267 13.0007 7.50267C13.1653 7.50267 13.2986 7.36942 13.2986 7.20475C13.2964 7.04009 13.1642 6.90684 12.9985 6.90684"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50115 13C7.50115 12.8353 7.3679 12.702 7.20432 12.7042C7.03965 12.7042 6.9064 12.8375 6.9064 13.0021C6.9064 13.1668 7.03965 13.3 7.20432 13.3C7.36898 13.3 7.50115 13.1657 7.50115 13"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3084 8.69075C17.1925 8.57484 17.004 8.57484 16.8892 8.69184C16.7733 8.80775 16.7733 8.99625 16.8892 9.11217C17.0051 9.22809 17.1936 9.22809 17.3095 9.11217C17.4254 8.99517 17.4254 8.80775 17.3084 8.69075"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.11019 16.8875C8.99428 16.7716 8.80578 16.7716 8.69094 16.8886C8.57503 17.0045 8.57503 17.193 8.69094 17.3089C8.80686 17.4249 8.99536 17.4249 9.11128 17.3089C9.22719 17.193 9.22719 17.0045 9.11019 16.8875"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.11182 9.11068C9.22773 8.99476 9.22773 8.80626 9.11073 8.69143C8.99482 8.57551 8.80632 8.57551 8.6904 8.69143C8.57448 8.80735 8.57448 8.99585 8.6904 9.11176C8.80632 9.22768 8.99482 9.22768 9.11182 9.11068"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0005 22.7495C7.52424 22.7495 3.10207 18.2342 3.25482 12.7233C3.39565 7.63592 7.6369 3.39467 12.7242 3.25384C18.2352 3.10109 22.7505 7.52326 22.7505 12.9995V14.0828C22.7505 15.2799 21.7809 16.2495 20.5838 16.2495H18.3489C16.9092 16.2495 15.8702 17.6275 16.2657 19.0109L16.5441 19.987C16.9406 21.3715 15.9006 22.7495 14.4619 22.7495H13.0005Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Cross = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0085 21.6217C15.7967 21.5104 14.0605 19.8739 12.3517 18.4651C11.0735 17.4114 9.64681 16.3521 8.24351 15.4796C6.35396 14.3049 3.86481 13.4939 3.39713 11.3187V11.3187C3.25505 10.6578 3.5125 9.83301 3.94582 9.31419C4.25213 8.94742 4.62055 8.56914 5.0459 8.27165C5.31748 8.08171 5.51871 7.79794 5.65473 7.49573C6.28796 6.08885 8.63008 4.03086 10.5504 3.57164C10.9444 3.47741 11.3196 3.72113 11.4839 4.0915C11.7686 4.73352 12.0535 5.37654 12.3381 6.01788C12.3747 6.10022 12.4257 6.18211 12.484 6.25082C14.9223 9.12637 14.0678 4.20974 15.6947 5.39343C15.8159 5.48159 15.9015 5.60981 15.9587 5.74833C16.7407 7.64279 17.521 9.53603 18.3031 11.4305C18.3382 11.5155 18.3849 11.5953 18.4418 11.6675C19.4888 12.9976 20.5346 14.3295 21.5797 15.6581C24.0491 19.5437 21.2804 21.7863 18.0085 21.6217ZM15.5634 8.10859C15.5233 8.03734 15.4726 7.95951 15.3927 7.94222C14.7865 7.81107 12.9867 9.67814 10.8392 6.1525C10.5623 5.69802 9.98901 5.49086 9.51236 5.72746C3.6655 8.62964 8.47723 10.1422 12.2949 12.7217C13.2169 13.3447 13.9313 14.2119 14.6401 15.0697C16.2091 16.9688 18.1288 18.4917 19.5 18.9995C20.9651 19.5985 22.1731 18.4971 18.7527 14.3047C18.5929 14.109 18.3597 13.9839 18.1099 13.946C14.4372 13.3874 17.7784 12.1909 16.7609 11.6557C16.461 11.4976 15.2893 12.0812 14.6661 11.394C13.9717 10.6236 16.9112 10.503 15.5634 8.10859ZM6.39614 10.1387C5.99512 9.73677 5.28388 9.65885 5.06719 10.1836C4.21253 12.2534 8.92713 14.0595 10.2749 15.0295C12.1962 16.5737 15.3944 19.2041 16.2476 19.5749C16.3192 19.606 16.3949 19.632 16.4651 19.6662C18.6373 20.7245 18.8987 20.4255 18.0632 19.711C16.7026 18.5476 15.1492 17.5982 13.873 16.3427C13.6589 16.1321 13.4449 15.9215 13.2311 15.7084C12.3623 14.842 11.4779 13.9886 10.4695 13.2897C9.16005 12.3822 7.59306 11.3382 6.39614 10.1387Z"
        fill="black"
      />
      <path
        d="M5 20H11"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3.5 17H7"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const CupcakeCherry = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9975 9.7451C11.3671 9.7451 10.04 8.42776 10.04 6.7876"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0391 6.78898C10.0391 5.49981 10.6273 4.57031 11.8114 4.57031"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.998 9.7451C14.6382 9.7451 15.9653 8.42776 15.9653 6.7876"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9637 6.78898C15.9637 5.49981 15.3668 4.57031 14.1816 4.57031"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1819 4.5709C13.5936 4.5709 13.2524 4.76048 12.9967 4.76048C12.741 4.76048 12.4084 4.5709 11.8115 4.5709"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 4.75784V3.68317C13 2.84575 13.6792 2.1665 14.5167 2.1665"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0476 6.90186C6.71742 7.82486 4.33301 10.2569 4.33301 13.1213V13.196C4.33301 14.6195 5.27767 15.9239 6.65026 16.1925C7.70434 16.3984 8.68259 16.0203 9.32826 15.3204C9.76376 14.8481 10.4788 14.8817 10.9208 15.3486C11.4451 15.9033 12.1828 16.2489 12.9997 16.2489C13.8165 16.2489 14.5543 15.9033 15.0797 15.3486C15.5217 14.8817 16.2356 14.8481 16.6722 15.3204C17.3178 16.0203 18.2961 16.3984 19.3502 16.1925C20.7217 15.9249 21.6663 14.6206 21.6663 13.1971V13.1224C21.6663 10.2591 19.283 7.82702 15.9539 6.90294"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3421 16.1948L18.6227 20.9106C18.4613 21.9679 17.5513 22.7501 16.481 22.7501H9.51733C8.447 22.7501 7.537 21.9679 7.37558 20.9106L6.65625 16.1948"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Dollar = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7V8.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3639 6.63604C22.8787 10.1508 22.8787 15.8492 19.3639 19.3639C15.8492 22.8787 10.1507 22.8787 6.63604 19.3639C3.12132 15.8492 3.12132 10.1507 6.63604 6.63604C10.1508 3.12132 15.8492 3.12132 19.3639 6.63604"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 19V17.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15.255C10 16.498 11.007 17.505 12.25 17.505H13.893C15.056 17.505 16 16.562 16 15.398C16 14.432 15.343 13.59 14.406 13.355L11.594 12.65C10.657 12.415 10 11.573 10 10.607C10 9.443 10.943 8.5 12.107 8.5H13.75C14.993 8.5 16 9.507 16 10.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Duotone = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7175 2.85861C18.1424 3.50834 19.7204 5.8422 19.4201 8.33453L18.9609 12.1462C18.8526 13.0455 18.9283 13.952 19.004 14.8585C19.0382 15.2669 19.0723 15.6753 19.0896 16.083C19.119 16.7769 19.0448 17.4869 18.8555 18.1933C17.855 21.9276 14.0166 24.1436 10.2823 23.1431C6.54807 22.1425 4.332 18.3041 5.33259 14.5698C5.52185 13.8635 5.81266 13.2114 6.18508 12.6252C6.4039 12.2808 6.63764 11.9442 6.87139 11.6076C7.39022 10.8604 7.90908 10.1132 8.26488 9.28024L9.77302 5.74959C10.7591 3.44103 13.2927 2.20888 15.7175 2.85861Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12.094"
        cy="16.3813"
        r="3"
        transform="rotate(15 12.094 16.3813)"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EcologyLeaf = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4429 22.0992C7.74638 22.0987 4.75 18.7266 4.75 14.5672C4.75 3.64422 16.4313 9.25122 22.0551 3.99922C22.1781 3.8956 22.3419 3.87712 22.4808 3.95122C22.6214 4.01743 22.722 4.16011 22.7474 4.32922C24.4644 15.6422 17.0632 22.0992 11.4429 22.0992Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1207 12.5527C11.3478 13.4104 8.74931 14.866 6.46972 16.8387L3.00195 20.1687"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HouseDoor = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.39121 11.4438L10.3274 4.35209C10.9947 3.68477 11.9421 3.36082 12.9207 3.37237C13.9003 3.38297 14.8932 3.72753 15.5799 4.41414L22.5796 11.4139C22.8307 11.6658 22.8932 12.0517 22.7341 12.3691L21.8094 14.2185L21.8406 19.979C21.8403 21.007 21.0127 21.8344 19.9846 21.8344H15.7976C14.8962 21.8344 14.1596 21.0977 14.1596 20.1974V15.8844C14.1596 15.3037 13.6902 14.8344 13.1096 14.8344H12.8596C12.2789 14.8344 11.8096 15.3037 11.8096 15.8844V20.1974C11.8096 21.0977 11.073 21.8344 10.1723 21.8344H5.98479C4.95623 21.8344 4.12876 21.0121 4.1286 19.9784L4.16002 14.2185L3.23512 12.3691C3.07942 12.0573 3.14224 11.6982 3.39121 11.4438ZM11.4859 5.51065C11.8407 5.15579 12.395 5.01085 12.9262 5.02242C13.4656 5.03318 14.0137 5.22902 14.3893 5.60464C14.9709 6.18522 19.9254 11.1397 20.8894 12.1047L20.9794 12.1948L20.2353 13.6492L20.2349 13.6502C20.1798 13.7614 20.1587 13.8732 20.1596 14.0085L20.1906 19.9784C20.1906 20.0621 20.1271 20.1844 19.9846 20.1844H15.8096V15.8844C15.8096 14.392 14.6019 13.1844 13.1096 13.1844H12.8596C11.3673 13.1844 10.1598 14.392 10.1598 15.8844V20.1844H5.98479C5.94422 20.1844 5.88568 20.173 5.83777 20.1251C5.7899 20.0772 5.7786 20.0178 5.7786 19.9775L5.8098 14.0083C5.81066 13.8721 5.78983 13.7605 5.73448 13.6495L4.99135 12.1643L11.4844 5.51215L11.4859 5.51065Z"
        fill="black"
      />
    </svg>
  );
};

export const MilkCarton = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 6.25H7L4.158 10.433C4.05456 10.6402 4.00048 10.8685 4 11.1V22.75C4 23.5784 4.67157 24.25 5.5 24.25H20.5C21.3284 24.25 22 23.5784 22 22.75V11.1C22.0001 10.8671 21.946 10.6374 21.842 10.429L19 6.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 3.25C19 2.42157 18.3284 1.75 17.5 1.75H8.5C7.67157 1.75 7 2.42157 7 3.25V6.25H19V3.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 10.75H18.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 21.25C14.6569 21.25 16 19.9069 16 18.25C16 16.5931 14.6569 15.25 13 15.25C11.3431 15.25 10 16.5931 10 18.25C10 19.9069 11.3431 21.25 13 21.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MobileDevices = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0316 20.5835H3.25033C2.65233 20.5835 2.16699 20.0982 2.16699 19.5002V18.4168C2.16699 17.8188 2.65233 17.3335 3.25033 17.3335H15.0316"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6667 5.41667C21.6667 4.21958 20.6971 3.25 19.5 3.25H5.41667C4.21958 3.25 3.25 4.21958 3.25 5.41667V17.3333"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1979 8.6665H21.6667C22.8638 8.6665 23.8333 9.63609 23.8333 10.8332V20.5832C23.8333 21.7803 22.8638 22.7498 21.6667 22.7498H17.1979C16.0008 22.7498 15.0312 21.7803 15.0312 20.5832V10.8332C15.0312 9.63609 16.0008 8.6665 17.1979 8.6665Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6667 8.6665V5.4165"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4814 20.3127H20.3773"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NaturalDisasterHurricane = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.521 7.24838C17.4621 7.24838 21.4677 6.39004 21.4677 5.33122C21.4677 4.2724 17.4621 3.41406 12.521 3.41406C7.57981 3.41406 3.57422 4.2724 3.57422 5.33122C3.57422 6.39004 7.57981 7.24838 12.521 7.24838Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3094 9.7832C18.2988 10.6268 14.2626 11.1738 10.1846 10.9761"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6753 13.8359C17.6989 14.3876 16.6147 14.7213 15.4971 14.8141"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.57343 5.33008C3.57343 5.33008 1.81731 9.38934 9.96396 14.2768C16.3545 18.1111 14.4373 22.5845 14.4373 22.5845C14.4373 22.5845 19.5498 20.6674 18.9107 16.194C17.6556 7.40487 21.4669 9.80345 21.4669 5.33008"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Notebook = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0029 22.0036H6.9979C5.89244 22.0036 4.99707 21.1082 4.99707 20.0028V5.99693C4.99707 4.89147 5.89244 3.99609 6.9979 3.99609H19.0029C20.1084 3.99609 21.0037 4.89147 21.0037 5.99693V20.0028C21.0037 21.1082 20.1084 22.0036 19.0029 22.0036Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99902 8.99826H17.0019"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99902 17.0022H17.0019"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99902 13.0002H17.0019"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.49609 8.99826H6.49734"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.49609 17.0022H6.29826"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.49609 13.0002H6.29826"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SeafoodSalmon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.49219 20.3359C9.63331 20.3359 12.1797 17.062 12.1797 13.0234C12.1797 8.98486 9.63331 5.71094 6.49219 5.71094C3.35107 5.71094 0.804688 8.98486 0.804688 13.0234C0.804688 17.062 3.35107 20.3359 6.49219 20.3359Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.49219 17.0859C7.83838 17.0859 8.92969 15.2671 8.92969 13.0234C8.92969 10.7798 7.83838 8.96094 6.49219 8.96094C5.14599 8.96094 4.05469 10.7798 4.05469 13.0234C4.05469 15.2671 5.14599 17.0859 6.49219 17.0859Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49219 20.3364C12.1797 20.3364 18.7339 18.5034 21.1172 13.8364C18.7339 9.16942 12.0464 5.16975 6.49219 5.71142"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1902 12.3572C23.3729 13.1946 22.2874 13.7184 21.1233 13.837C21.071 12.6517 21.4232 11.4839 22.1221 10.5252C22.9393 9.68775 24.0248 9.16398 25.189 9.04541C25.2413 10.2307 24.8891 11.3985 24.1902 12.3572Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1902 15.3147C23.3726 14.4777 22.2872 13.9544 21.1232 13.8359C21.071 15.0212 21.4232 16.189 22.1221 17.1477C22.9388 17.9866 24.0243 18.5119 25.189 18.6319C25.2425 17.4448 24.8902 16.2748 24.1902 15.3147Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SeasiningSalt = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.437 9.25H8.563C8.11399 9.25 7.75 8.88601 7.75 8.437V7C7.75 4.10051 10.1005 1.75 13 1.75V1.75C15.8995 1.75 18.25 4.10051 18.25 7V8.437C18.25 8.88601 17.886 9.25 17.437 9.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.875 4.75C15.0821 4.75 15.25 4.91789 15.25 5.125C15.25 5.33211 15.0821 5.5 14.875 5.5C14.6679 5.5 14.5 5.33211 14.5 5.125C14.5 4.91789 14.6679 4.75 14.875 4.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.125 4.75C11.3321 4.75 11.5 4.91789 11.5 5.125C11.5 5.33211 11.3321 5.5 11.125 5.5C10.9179 5.5 10.75 5.33211 10.75 5.125C10.75 4.91789 10.9179 4.75 11.125 4.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7504 9.25H9.25041C5.37441 17.0013 5.25374 21.9347 8.88841 24.05C9.12241 24.1829 9.38729 24.2519 9.65641 24.25H16.3444C16.6135 24.2519 16.8784 24.1829 17.1124 24.05C20.7464 21.9347 20.6257 17.0013 16.7504 9.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.48047 16.75H19.5205"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.28223 19.75H19.7182"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SofaChair = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4993 15.1673H6.49935V12.459C6.49935 11.562 5.77135 10.834 4.87435 10.834H3.79102C2.89402 10.834 2.16602 11.562 2.16602 12.459V17.334C2.16602 18.5311 3.1356 19.5007 4.33268 19.5007H21.666C22.8631 19.5007 23.8327 18.5311 23.8327 17.334V12.459C23.8327 11.562 23.1047 10.834 22.2077 10.834H21.1243C20.2273 10.834 19.4993 11.562 19.4993 12.459V15.1673Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41569 19.501V21.6676"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5827 19.501V21.6676"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33301 10.8341V8.66748C4.33301 6.8724 5.78792 5.41748 7.58301 5.41748H18.4163C20.2114 5.41748 21.6663 6.8724 21.6663 8.66748V10.8341"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SoftDrinksCanCoffee = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75 7.75H18.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 7.75L9.25 4.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.875 4.75C15.0821 4.75 15.25 4.91789 15.25 5.125C15.25 5.33211 15.0821 5.5 14.875 5.5C14.6679 5.5 14.5 5.33211 14.5 5.125C14.5 4.91789 14.6679 4.75 14.875 4.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.125 2.5C17.3321 2.5 17.5 2.66789 17.5 2.875C17.5 3.08211 17.3321 3.25 17.125 3.25C16.9179 3.25 16.75 3.08211 16.75 2.875C16.75 2.66789 16.9179 2.5 17.125 2.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.625 1.75C12.8321 1.75 13 1.91789 13 2.125C13 2.33211 12.8321 2.5 12.625 2.5C12.4179 2.5 12.25 2.33211 12.25 2.125C12.25 1.91789 12.4179 1.75 12.625 1.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7.75L7.329 11.089C7.11612 11.3549 7.0001 11.6854 7 12.026V21.546C7.00003 21.8421 7.08772 22.1316 7.252 22.378L8.052 23.578C8.32925 23.9968 8.79773 24.2491 9.3 24.25H16.7C17.2015 24.25 17.6698 23.9993 17.948 23.582L18.748 22.382C18.913 22.1345 19.0008 21.8435 19 21.546V12.026C18.9999 11.6854 18.8839 11.3549 18.671 11.089L16 7.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 18.25C14.6569 18.25 16 16.9069 16 15.25C16 13.5931 14.6569 12.25 13 12.25C11.3431 12.25 10 13.5931 10 15.25C10 16.9069 11.3431 18.25 13 18.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Stomach = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0036 14.0003V12.9998C22.0036 9.13223 18.8683 5.99693 15.0007 5.99693H14.0003C13.1159 5.99693 12.3666 5.42369 12.1015 4.62836C11.9704 4.23319 11.5632 3.99609 11.1481 3.99609H10.1306C9.47838 3.99609 8.99317 4.61435 9.15624 5.24561C9.49338 6.55316 10.3477 7.65162 11.4862 8.31489C11.7913 8.49297 11.9994 8.79309 11.9994 9.14624C11.9994 10.6459 11.9994 14.5865 11.9994 14.5865C11.9994 15.3678 11.3662 16.0011 10.5848 16.0011C10.2097 16.0011 9.84953 15.852 9.58442 15.5869L8.82711 14.8296C8.01177 14.0143 6.74924 13.7482 5.61477 14.2694C4.59434 14.7376 3.99609 15.821 3.99609 16.9435V20.0028C3.99609 20.8311 4.66837 21.5034 5.49672 21.5034C6.32506 21.5034 6.99734 20.8311 6.99734 20.0028V18.0019L9.10422 20.1088C10.3177 21.3223 11.9624 22.0036 13.6781 22.0036V22.0036C18.276 22.0036 22.0036 18.276 22.0036 13.6781"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ToolsKitchenServingDome = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.8125 17H25.1875"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.8418 17L3.52638 19.5263C3.82709 19.9774 4.33298 20.2489 4.87513 20.25H21.1251C21.6684 20.25 22.1758 19.9784 22.4771 19.5263L24.1585 17"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5327 17.0004C23.1046 11.4814 18.4885 7.22897 12.953 7.25402C7.41749 7.27906 2.84013 11.5731 2.46191 17.0957"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 7.25C13.8975 7.25 14.625 6.52246 14.625 5.625C14.625 4.72754 13.8975 4 13 4C12.1025 4 11.375 4.72754 11.375 5.625C11.375 6.52246 12.1025 7.25 13 7.25Z"
        stroke="black"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TravelVacationHolidayUmbrella = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9997 16.25V9.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 9.75C9.75 6.175 11.1583 3.25 13 3.25C14.8417 3.25 16.25 6.175 16.25 9.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.69167 19.5L6.5 22.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2246 19.5L18.4163 22.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.875 19.5003H16.9C18.0917 19.5003 19.175 19.067 20.15 18.417L22.1 16.9003C22.6417 16.467 22.8583 15.7086 22.6417 15.0586V15.0586C22.3167 13.9753 21.0167 13.6503 20.15 14.3003L18.2 15.817C17.875 16.142 17.3333 16.2503 16.9 16.2503H4.875C4.00833 16.2503 3.25 17.0086 3.25 17.8753V17.8753C3.25 18.742 4.00833 19.5003 4.875 19.5003Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33301 9.75H21.6663C21.6663 6.5 17.333 3.25 12.9997 3.25C8.66634 3.25 4.33301 6.5 4.33301 9.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VegetablesSalad = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.249 14.125C24.249 19.096 19.213 23.125 12.999 23.125C6.78502 23.125 1.74902 19.1 1.74902 14.125H24.249Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.74002 11.125C9.25269 10.2357 8.57237 9.46692 7.74902 8.875"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1734 7.85214C13.3532 6.75982 12.9168 5.65727 12.0381 4.98387C11.1595 4.31046 9.98144 4.17564 8.97339 4.63314C8.28773 3.1243 6.50873 2.45698 4.99989 3.14264C3.49105 3.8283 2.82373 5.6073 3.50939 7.11614C2.00121 7.80163 1.33416 9.57984 2.01939 11.0881L2.03639 11.1241"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6742 11.1232C22.9767 9.63324 22.3497 8.10806 21.0867 7.26171C19.8237 6.41537 18.1747 6.41537 16.9117 7.26171C15.6487 8.10806 15.0216 9.63324 15.3242 11.1232"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WaterBottle = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4411 5.97C15.3159 5.74633 15.2502 5.49431 15.2501 5.238V2.5C15.2501 2.08579 14.9143 1.75 14.5001 1.75H11.5001C11.0859 1.75 10.7501 2.08579 10.7501 2.5V5.238C10.75 5.49431 10.6842 5.74633 10.5591 5.97L8.95008 8.847C8.16605 10.0903 7.75001 11.5301 7.75008 13V13V22.333C7.74278 23.0224 8.2121 23.6256 8.88208 23.788C11.5929 24.404 14.4073 24.404 17.1181 23.788C17.7881 23.6256 18.2574 23.0224 18.2501 22.333V13V13C18.2502 11.5301 17.8341 10.0903 17.0501 8.847L15.4411 5.97Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.75 4.75H15.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WeatherNightClear = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6721 17.0625C15.324 17.0617 12.1745 15.474 10.1827 12.7829C8.19085 10.0918 7.59256 6.61579 8.56999 3.41357C4.1625 5.44513 1.70758 10.2197 2.61963 14.9864C3.53168 19.7531 7.57577 23.2841 12.4219 23.5451C17.2681 23.806 21.668 20.7298 23.0867 16.0886C21.7033 16.73 20.1969 17.0624 18.6721 17.0625V17.0625Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9844 4.0625H17.8594"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4219 1.625V6.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2969 8.9375H23.5469"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9219 7.3125V10.5625"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WeatherNight = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6721 17.0625C15.324 17.0617 12.1745 15.474 10.1827 12.7829C8.19085 10.0918 7.59256 6.61579 8.56999 3.41357C4.1625 5.44513 1.70758 10.2197 2.61963 14.9864C3.53168 19.7531 7.57577 23.2841 12.4219 23.5451C17.2681 23.806 21.668 20.7298 23.0867 16.0886C21.7033 16.73 20.1969 17.0624 18.6721 17.0625V17.0625Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9844 4.0625H17.8594"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4219 1.625V6.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2969 8.9375H23.5469"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9219 7.3125V10.5625"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Furniture = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4993 15.1673H6.49935V12.459C6.49935 11.562 5.77135 10.834 4.87435 10.834H3.79102C2.89402 10.834 2.16602 11.562 2.16602 12.459V17.334C2.16602 18.5311 3.1356 19.5007 4.33268 19.5007H21.666C22.8631 19.5007 23.8327 18.5311 23.8327 17.334V12.459C23.8327 11.562 23.1047 10.834 22.2077 10.834H21.1243C20.2273 10.834 19.4993 11.562 19.4993 12.459V15.1673Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41569 19.501V21.6676"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5827 19.501V21.6676"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33301 10.8341V8.66748C4.33301 6.8724 5.78792 5.41748 7.58301 5.41748H18.4163C20.2114 5.41748 21.6663 6.8724 21.6663 8.66748V10.8341"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Warning = ({ color = "#F7C056" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22ZM11.4219 9.7453L12.0799 13.7213H12.9619L13.6059 9.7453V7.0293H11.4219V9.7453ZM11.5339 16.6613C11.7299 16.8666 12.0519 16.9693 12.4999 16.9693C12.9479 16.9693 13.2652 16.8666 13.4519 16.6613C13.6479 16.456 13.7459 16.204 13.7459 15.9053V15.5693C13.7459 15.2706 13.6479 15.0186 13.4519 14.8133C13.2652 14.608 12.9479 14.5053 12.4999 14.5053C12.0519 14.5053 11.7299 14.608 11.5339 14.8133C11.3472 15.0186 11.2539 15.2706 11.2539 15.5693V15.9053C11.2539 16.204 11.3472 16.456 11.5339 16.6613Z"
        fill={color}
      />
    </svg>
  );
};

export const Check = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 12C2.5 17.5228 6.97715 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12ZM17.2372 9.67572C17.6103 9.26861 17.5828 8.63604 17.1757 8.26285C16.7686 7.88965 16.136 7.91716 15.7628 8.32428L11.0359 13.481L9.26822 11.3598C8.91466 10.9355 8.28409 10.8782 7.85982 11.2318C7.43554 11.5853 7.37821 12.2159 7.73178 12.6402L10.2318 15.6402C10.4165 15.8618 10.6879 15.9929 10.9764 15.9997C11.2648 16.0065 11.5422 15.8884 11.7372 15.6757L17.2372 9.67572Z"
        fill="#058D66"
      />
    </svg>
  );
};

export const Scale = ({ color = "black" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3.5" y="3" width="18" height="18" rx="4" fill={color} />
      <path
        d="M14.84 10.7201C15.5576 10.7999 16.2691 10.9268 16.97 11.1001L18 7.00009C14.3771 6.19854 10.6229 6.19854 7 7.00009L8 11.0701C9.4787 10.7518 10.9875 10.5942 12.5 10.6001L13.91 8.42009"
        fill="white"
        fillOpacity="0.24"
      />
      <path
        d="M14.84 10.7201C15.5576 10.7999 16.2691 10.9268 16.97 11.1001L18 7.00009C14.3771 6.19854 10.6229 6.19854 7 7.00009L8 11.0701C9.4787 10.7518 10.9875 10.5942 12.5 10.6001L13.91 8.42009"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PersonCircle = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4981 1.95312C6.97521 1.95312 2.5168 6.43012 2.4981 11.9531C2.4794 17.4681 6.97981 21.9731 12.4981 21.9841C18.0164 21.9951 22.508 17.4291 22.4981 11.9531C22.4881 6.43012 18.0209 1.95312 12.4981 1.95312ZM12.4981 3.95312C16.9164 3.95312 20.498 7.53512 20.4981 11.9531C20.4981 14.2031 19.5609 16.2311 18.0659 17.6851C17.3295 16.0921 15.7476 14.9531 13.9356 14.9531C13.5762 14.9531 11.4198 14.9531 11.0606 14.9531C9.24971 14.9531 7.67241 16.0781 6.93561 17.6721C5.44061 16.2181 4.49811 14.2031 4.49811 11.9531C4.49811 7.53512 8.07981 3.95312 12.4981 3.95312ZM12.4981 5.95312C10.2889 5.95312 8.49801 7.74412 8.49811 9.95312C8.49811 12.1621 10.2889 13.9531 12.4981 13.9531C14.7072 13.9531 16.4982 12.1621 16.4981 9.95312C16.4981 7.74412 14.7072 5.95312 12.4981 5.95312Z"
        fill="black"
      />
    </svg>
  );
};

export const Back = () => {
  return (
    <svg
      width="21"
      height="12"
      viewBox="0 0 21 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9863 5.9848C20.9863 5.4338 20.5393 4.98779 19.9883 4.98779L4.4243 4.9978L7.39232 1.9978L5.98631 0.591797L1.26731 5.27881C0.877308 5.66981 0.877308 6.3258 1.26731 6.7168L5.98631 11.4038L7.39232 9.9978L4.4243 6.9978L19.9883 6.98279C20.5393 6.98279 20.9863 6.5358 20.9863 5.9848Z"
        fill="black"
      />
    </svg>
  );
};

export const FitnessSlimWaist = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.584 1.6875C1.23925 3.03225 1.45192 5.994 3.4805 7.51658C5.27442 8.86133 6.17092 9.75783 6.17092 13.3448C6.17092 16.9317 1.6875 19.1738 1.6875 22.3125"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.415 1.6875C22.7598 3.03225 22.5471 5.99583 20.5185 7.51658C18.7246 8.86133 17.8281 9.75783 17.8281 13.3448C17.8281 16.9317 22.3115 19.1738 22.3115 22.3125"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9995 8.85769C15.6078 8.93835 15.2283 7.5166 12.0007 7.5166C8.77312 7.5166 8.39087 8.93835 5.00195 8.85769"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.48047 18.7256C5.72264 18.7256 8.8613 20.5195 12 20.5195C15.1386 20.5195 18.2773 18.7256 20.5195 18.7256"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.207 1.6875C11.1035 1.6875 12 3.03225 12 3.03225C12.2664 2.25948 12.9766 1.72686 13.793 1.6875"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16.8125C12.1898 16.8125 12.3438 16.9664 12.3438 17.1562"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6562 17.1562C11.6562 16.9664 11.8102 16.8125 12 16.8125"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.5C11.8102 17.5 11.6562 17.3461 11.6562 17.1562"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3438 17.1562C12.3438 17.3461 12.1898 17.5 12 17.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FitnessWeights = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 11.5H15.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 17.5C5.92157 17.5 5.25 16.8284 5.25 16V7C5.25 6.17157 5.92157 5.5 6.75 5.5C7.57843 5.5 8.25 6.17157 8.25 7V16C8.25 16.8284 7.57843 17.5 6.75 17.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 11.5H0.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 8.5C2.92157 8.5 2.25 9.17157 2.25 10V13C2.25 13.8284 2.92157 14.5 3.75 14.5C4.57843 14.5 5.25 13.8284 5.25 13V10C5.25 9.17157 4.57843 8.5 3.75 8.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.25 17.5C18.0784 17.5 18.75 16.8284 18.75 16V7C18.75 6.17157 18.0784 5.5 17.25 5.5C16.4216 5.5 15.75 6.17157 15.75 7V16C15.75 16.8284 16.4216 17.5 17.25 17.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.75 11.5H23.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.25 8.5C21.0784 8.5 21.75 9.17157 21.75 10V13C21.75 13.8284 21.0784 14.5 20.25 14.5C19.4216 14.5 18.75 13.8284 18.75 13V10C18.75 9.17157 19.4216 8.5 20.25 8.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Fire = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7891 17.7803C9.98047 17.7803 9.32715 17.5576 8.8291 17.1123C8.33691 16.667 8.09082 16.0811 8.09082 15.3545C8.09082 14.9736 8.14648 14.6484 8.25781 14.3789C8.36914 14.1094 8.49805 13.8662 8.64453 13.6494C8.79102 13.4268 8.92578 13.21 9.04883 12.999C9.17773 12.7881 9.25977 12.5479 9.29492 12.2783C9.30078 12.2256 9.32129 12.1934 9.35645 12.1816C9.39746 12.1641 9.43848 12.1729 9.47949 12.208C9.67871 12.3896 9.84277 12.5889 9.97168 12.8057C10.1064 13.0225 10.2266 13.2598 10.332 13.5176C10.5547 13.1836 10.707 12.7236 10.7891 12.1377C10.8711 11.5459 10.874 10.9102 10.7979 10.2305C10.7861 10.1719 10.7979 10.1279 10.833 10.0986C10.8682 10.0693 10.915 10.0664 10.9736 10.0898C11.6006 10.3828 12.1279 10.7695 12.5557 11.25C12.9893 11.7246 13.3145 12.252 13.5312 12.832C13.748 13.4062 13.8564 13.9834 13.8564 14.5635C13.8564 15.1436 13.7422 15.6797 13.5137 16.1719C13.2852 16.6582 12.9424 17.0479 12.4854 17.3408C12.0342 17.6338 11.4688 17.7803 10.7891 17.7803Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5781 20.4873C9.16016 20.4873 7.92383 20.2324 6.86914 19.7227C5.81445 19.2188 4.99414 18.5098 4.4082 17.5957C3.82227 16.6758 3.5293 15.6035 3.5293 14.3789C3.5293 13.7344 3.5791 13.166 3.67871 12.6738C3.78418 12.1758 3.91309 11.7334 4.06543 11.3467C4.21777 10.9541 4.37012 10.585 4.52246 10.2393C4.68066 9.89355 4.80957 9.54785 4.90918 9.20215C5.00879 8.85645 5.05859 8.48438 5.05859 8.08594C5.05859 7.86914 5.04688 7.65234 5.02344 7.43555C5.00586 7.21289 4.99707 7.03418 4.99707 6.89941C4.99707 6.6709 5.06152 6.48926 5.19043 6.35449C5.31934 6.21973 5.48633 6.15234 5.69141 6.15234C5.99023 6.15234 6.28906 6.2373 6.58789 6.40723C6.89258 6.57715 7.1709 6.82324 7.42285 7.14551C7.6748 7.46777 7.67578 7.45312 7.85352 7.85742C7.88281 7.69336 7.89746 7.52637 7.89746 7.35645C7.89746 6.79395 7.79492 6.26074 7.58984 5.75684C7.39062 5.24707 7.13281 4.76074 6.81641 4.29785C6.5 3.8291 6.16016 3.37793 5.79688 2.94434C5.69727 2.83301 5.62109 2.71582 5.56836 2.59277C5.51562 2.46387 5.48926 2.33496 5.48926 2.20605C5.48926 1.88379 5.62402 1.64062 5.89355 1.47656C6.16309 1.3125 6.52637 1.23047 6.9834 1.23047C7.7627 1.23047 8.58594 1.32422 9.45312 1.51172C10.3203 1.69922 11.1816 1.98926 12.0371 2.38184C12.8926 2.77441 13.7041 3.27539 14.4717 3.88477C15.2451 4.48828 15.9307 5.20898 16.5283 6.04688C17.126 6.87891 17.5977 7.83105 17.9434 8.90332C18.2891 9.97559 18.4619 11.1738 18.4619 12.498C18.4619 13.6934 18.2744 14.7832 17.8994 15.7676C17.5244 16.7461 16.9883 17.5869 16.291 18.29C15.5938 18.9932 14.7617 19.5352 13.7949 19.916C12.834 20.2969 11.7617 20.4873 10.5781 20.4873ZM13.9443 18.1846C13.0068 18.7354 11.9141 19.0107 10.666 19.0107C9.54102 19.0107 8.55371 18.8145 7.7041 18.4219C6.85449 18.0352 6.19531 17.4961 5.72656 16.8047C5.25781 16.1133 5.02344 15.3047 5.02344 14.3789C5.02344 13.8281 5.07324 13.3389 5.17285 12.9111C5.27246 12.4834 5.39844 12.0908 5.55078 11.7334C5.70312 11.376 5.85254 11.0244 5.99902 10.6787C6.15137 10.3271 6.27734 9.95508 6.37695 9.5625C6.47656 9.16992 6.52637 8.72461 6.52637 8.22656C6.52637 8.16119 6.52387 8.09732 6.51886 8.03495C6.58891 8.1143 6.65587 8.19868 6.71973 8.28809C6.90137 8.53418 7.05664 8.81543 7.18555 9.13184C7.31445 9.44238 7.42285 9.79102 7.51074 10.1777C7.53418 10.2949 7.5752 10.3857 7.63379 10.4502C7.69824 10.5088 7.78027 10.5381 7.87988 10.5381C8.0791 10.5381 8.26074 10.4385 8.4248 10.2393C8.58887 10.04 8.72949 9.78516 8.84668 9.47461C8.96973 9.1582 9.06348 8.82129 9.12793 8.46387C9.19238 8.10645 9.22461 7.76953 9.22461 7.45312C9.22461 6.79102 9.13379 6.14648 8.95215 5.51953C8.77637 4.88672 8.52148 4.29492 8.1875 3.74414C7.96126 3.36034 7.70437 3.00439 7.41685 2.6763C8.37797 2.75251 9.27939 2.92389 10.1211 3.19043C11.1816 3.52441 12.1279 3.98438 12.96 4.57031C13.7979 5.15625 14.5098 5.85059 15.0957 6.65332C15.6875 7.45605 16.1387 8.34668 16.4492 9.3252C16.7598 10.2979 16.915 11.3408 16.915 12.4541C16.915 13.7607 16.6543 14.9062 16.1328 15.8906C15.6113 16.8691 14.8818 17.6338 13.9443 18.1846Z"
        fill="black"
      />
    </svg>
  );
};

export const Running = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2852 19.9911C13.9775 19.8741 12.1662 18.1543 10.3834 16.6737C9.04986 15.5662 7.56133 14.453 6.09725 13.5361C4.12586 12.3015 1.52889 11.4492 1.04096 9.1631C0.892718 8.46855 1.16132 7.60176 1.61341 7.0565C1.93299 6.67104 2.31736 6.27349 2.76114 5.96084C3.04449 5.76122 3.25443 5.46299 3.39634 5.14538C4.057 3.66682 6.50056 1.50397 8.50403 1.02136C8.91515 0.922322 9.30659 1.17846 9.47796 1.5677C9.77502 2.24244 10.0723 2.91822 10.3692 3.59224C10.4073 3.67877 10.4606 3.76484 10.5214 3.83704C13.0653 6.85911 12.1738 1.69197 13.8712 2.93597C13.9976 3.02862 14.0869 3.16338 14.1466 3.30896C14.9625 5.29994 15.7766 7.28965 16.5926 9.28067C16.6292 9.37 16.6779 9.45382 16.7372 9.52975C17.8296 10.9276 18.9207 12.3274 20.0111 13.7237C22.5874 17.8073 19.6988 20.1641 16.2852 19.9911ZM13.7342 5.78947C13.6924 5.71459 13.6394 5.63279 13.5561 5.61462C12.9236 5.47679 11.0458 7.439 8.80532 3.73371C8.51651 3.25608 7.91835 3.03836 7.42105 3.28701C1.32095 6.33708 6.3411 7.92667 10.3241 10.6377C11.2861 11.2924 12.0314 12.2037 12.7708 13.1053C14.4079 15.1011 16.4107 16.7016 17.8413 17.2353C19.3698 17.8648 20.6302 16.7073 17.0616 12.3013C16.8949 12.0956 16.6516 11.9642 16.391 11.9243C12.5592 11.3372 16.0451 10.0798 14.9835 9.51734C14.6707 9.35121 13.4482 9.96447 12.798 9.24232C12.0735 8.43267 15.1403 8.30586 13.7342 5.78947ZM4.16986 7.923C3.75147 7.50062 3.00942 7.41872 2.78335 7.97023C1.89167 10.1455 6.81048 12.0436 8.21659 13.0631C10.2211 14.6859 13.5579 17.4504 14.448 17.84C14.5227 17.8727 14.6017 17.9 14.6749 17.936C16.9413 19.0482 17.214 18.7339 16.3422 17.9831C14.9227 16.7604 13.302 15.7626 11.9706 14.4431C11.7472 14.2218 11.5239 14.0005 11.3008 13.7765C10.3944 12.866 9.47173 11.9691 8.41966 11.2346C7.05348 10.2808 5.41862 9.18367 4.16986 7.923Z"
        fill="black"
      />
      <path
        d="M3 18H9"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1 15H5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Travel = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 20H5C3.895 20 3 19.105 3 18V9.5C3 8.395 3.895 7.5 5 7.5H19C20.105 7.5 21 8.395 21 9.5V18C21 19.105 20.105 20 19 20Z"
        stroke="black"
        strokeWidth="1.5566"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6445 7.50073V5.92773C15.6445 4.82273 14.7495 3.92773 13.6445 3.92773H10.3535C9.24852 3.92773 8.35352 4.82273 8.35352 5.92773V7.50073"
        stroke="black"
        strokeWidth="1.3416"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 7.5V20"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 13V7.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 13H18V16H13V13Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 20V16"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WineGlass = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3398 22.1499H15.6594"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.998 22.1498V14.7544"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.104 7.90842C19.4397 10.0055 18.583 12.1151 16.8574 13.4407V13.4407C14.6011 15.1736 11.395 15.1736 9.13874 13.4407V13.4407C7.41307 12.1151 6.55641 10.0055 6.89214 7.90842L7.58988 3.54132C7.63986 3.22935 7.91983 2.99928 8.24861 3H17.7475C18.0756 3.00012 18.3546 3.22999 18.4044 3.54132L19.104 7.90842Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.86328 8.10645H19.1318"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AmericanFootbal = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9964 5.75687C23.0239 5.01812 22.7425 4.3013 22.2197 3.77856C21.697 3.25582 20.9802 2.97439 20.2414 3.00184C16.9798 3.12626 11.4529 3.93499 7.69534 7.69517C3.93783 11.4553 3.12732 16.9761 3.00379 20.243C2.97634 20.9818 3.25777 21.6986 3.78051 22.2213C4.30325 22.7441 5.02007 23.0255 5.75882 22.998C9.02487 22.8754 14.5518 22.0649 18.3093 18.3065C22.0668 14.5481 22.8729 9.02381 22.9964 5.75687Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3334 9.66748L9.66797 16.3329"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12L13.9996 13.9996"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66797 14.333L11.6676 16.3326"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.334 9.66748L16.3336 11.6671"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.60156 15.6001L10.3985 22.397"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3965 10.399L15.5996 3.60205"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Users = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 15L8.25012 14.9654C8.25037 14.8928 8.21902 14.8236 8.16423 14.7759C8.10944 14.7283 8.03662 14.7068 7.96472 14.7171C7.81307 14.7388 7.65792 14.75 7.5 14.75C7.39764 14.75 7.29645 14.7453 7.19663 14.736C7.17457 14.734 7.15233 14.7349 7.13051 14.7387C7.08829 14.7461 7.0447 14.75 7 14.75H6.57143C5.56548 14.75 4.75 15.5655 4.75 16.5714V19C4.75 19.4142 4.41421 19.75 4 19.75C3.58579 19.75 3.25 19.4142 3.25 19V16.5714C3.25 15.3896 3.86702 14.3518 4.79767 13.7627C4.85599 13.7258 4.89646 13.6664 4.90948 13.5986C4.92249 13.5309 4.9069 13.4607 4.8664 13.4048C4.47858 12.8696 4.25 12.2119 4.25 11.5C4.25 9.70507 5.70507 8.25 7.5 8.25C8.00424 8.25 8.481 8.36466 8.90625 8.56909C8.98713 8.60797 9.08264 8.60052 9.15651 8.54957C9.23038 8.49862 9.27128 8.41199 9.26367 8.32257C9.25462 8.21631 9.25 8.10872 9.25 8C9.25 5.92893 10.9289 4.25 13 4.25C15.0711 4.25 16.75 5.92893 16.75 8C16.75 8.10872 16.7454 8.21631 16.7363 8.32258C16.7287 8.41199 16.7696 8.49863 16.8435 8.54958C16.9174 8.60053 17.0129 8.60798 17.0938 8.5691C17.519 8.36466 17.9958 8.25 18.5 8.25C20.2949 8.25 21.75 9.70507 21.75 11.5C21.75 12.2119 21.5214 12.8696 21.1336 13.4048C21.0931 13.4607 21.0775 13.5309 21.0905 13.5986C21.1035 13.6664 21.144 13.7258 21.2023 13.7627C22.133 14.3518 22.75 15.3896 22.75 16.5714V19C22.75 19.4142 22.4142 19.75 22 19.75C21.5858 19.75 21.25 19.4142 21.25 19V16.5714C21.25 15.5655 20.4345 14.75 19.4286 14.75H19C18.9553 14.75 18.9117 14.7461 18.8695 14.7387C18.8477 14.7349 18.8254 14.734 18.8034 14.736C18.7035 14.7453 18.6024 14.75 18.5 14.75C18.3421 14.75 18.1869 14.7388 18.0353 14.7171C17.9634 14.7068 17.8906 14.7283 17.8358 14.7759C17.781 14.8236 17.7496 14.8928 17.7499 14.9654L17.75 15V21C17.75 21.4142 17.4142 21.75 17 21.75C16.5858 21.75 16.25 21.4142 16.25 21V15C16.25 13.2051 14.7949 11.75 13 11.75C11.2051 11.75 9.75 13.2051 9.75 15V21C9.75 21.4142 9.41421 21.75 9 21.75C8.58579 21.75 8.25 21.4142 8.25 21V15ZM13 10.25C11.7574 10.25 10.75 9.24264 10.75 8C10.75 6.75736 11.7574 5.75 13 5.75C14.2426 5.75 15.25 6.75736 15.25 8C15.25 9.24264 14.2426 10.25 13 10.25ZM5.75 11.5C5.75 10.5335 6.5335 9.75 7.5 9.75C8.4665 9.75 9.25 10.5335 9.25 11.5C9.25 12.4665 8.4665 13.25 7.5 13.25C6.5335 13.25 5.75 12.4665 5.75 11.5ZM16.75 11.5C16.75 10.5335 17.5335 9.75 18.5 9.75C19.4665 9.75 20.25 10.5335 20.25 11.5C20.25 12.4665 19.4665 13.25 18.5 13.25C17.5335 13.25 16.75 12.4665 16.75 11.5Z"
        fill="black"
      />
    </svg>
  );
};

export const Reward = ({ color = "black" } = {}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.45 3.125C16.9669 3.125 16.575 3.51716 16.575 4.00125V4.05259C16.575 4.53667 16.9669 4.92883 17.45 4.92883C17.9331 4.92883 18.325 4.53667 18.325 4.05259V4.00124C18.325 3.51716 17.9331 3.125 17.45 3.125ZM13.7997 4.19464C13.329 4.09122 12.8684 4.39061 12.7707 4.86459L12.2707 7.2919C12.1728 7.76712 12.4771 8.23658 12.9491 8.34028C13.4199 8.44369 13.8805 8.1443 13.9781 7.67033L14.4781 5.24302C14.576 4.7678 14.2717 4.29833 13.7997 4.19464ZM19.1955 7.5049C18.859 7.15936 18.3149 7.15936 17.9784 7.50489L16.745 8.77149C16.4067 9.11888 16.4067 9.68346 16.745 10.0309C17.0814 10.3764 17.6256 10.3764 17.962 10.0309L19.1955 8.76427C19.5338 8.41688 19.5338 7.8523 19.1955 7.5049ZM9.12274 7.72275C8.67314 7.57384 8.18369 7.81276 8.02157 8.26266L3.17734 21.7048C3.06402 22.0193 3.13801 22.3693 3.36732 22.6084C3.59658 22.8474 3.94207 22.9348 4.25925 22.8334L17.3896 18.6384C17.8087 18.5045 18.066 18.0803 17.991 17.647C17.4724 14.6519 15.8669 12.3734 14.108 10.7552C12.3565 9.14373 10.4153 8.15085 9.12274 7.72275ZM21.4492 8.25958C20.9661 8.25958 20.5742 8.65174 20.5742 9.13582V9.18717C20.5742 9.67125 20.9661 10.0634 21.4492 10.0634C21.9323 10.0634 22.3242 9.67125 22.3242 9.18717V9.13582C22.3242 8.65174 21.9323 8.25958 21.4492 8.25958ZM10.134 10.073L10.4252 10.2378C11.2213 10.6883 12.0939 11.2904 12.9214 12.0517C14.0635 13.1024 15.0984 14.4358 15.7404 16.0708L15.8604 16.3765L15.5675 16.228C14.5656 15.72 13.2985 14.9123 12.1335 13.6882C11.2403 12.7498 10.634 11.4832 10.2458 10.3883L10.134 10.073ZM8.74673 11.398L8.87023 11.6968C9.30703 12.7535 9.94678 13.9394 10.865 14.9042C12.0279 16.1261 13.2736 16.9798 14.3248 17.559L14.5791 17.6992L5.42156 20.6249L8.74673 11.398ZM22.8704 13.2766C22.8385 12.7935 22.4216 12.4281 21.9396 12.4601L19.3954 12.6286C18.9133 12.6605 18.5481 13.0777 18.58 13.5607C18.6119 14.0438 19.0288 14.4092 19.5109 14.3772L22.0551 14.2087C22.5371 14.1768 22.9023 13.7596 22.8704 13.2766Z"
        fill={color}
      />
    </svg>
  );
};

export const Star = ({ color = "black" }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0139 5.74526C14.5606 5.11861 15.5888 5.39419 15.7488 6.21025L16.5386 10.2387C16.602 10.562 16.8206 10.8334 17.1231 10.9642L20.8836 12.5898C21.6421 12.9177 21.6981 13.9719 20.9786 14.3784L17.3913 16.4051C17.1061 16.5662 16.918 16.8566 16.8875 17.1827L16.5034 21.2914C16.4262 22.1176 15.4344 22.4957 14.8268 21.9307L11.8366 19.1502C11.5939 18.9246 11.2552 18.8338 10.9321 18.9079L6.95234 19.8207C6.14359 20.0062 5.47378 19.1829 5.81997 18.4288L7.54174 14.6785C7.67837 14.3809 7.66063 14.0352 7.49425 13.7532L5.40081 10.2043C4.98097 9.49256 5.55657 8.60763 6.3774 8.70288L10.4461 9.17505C10.7734 9.21303 11.0983 9.08737 11.3149 8.8391L14.0139 5.74526Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StarIcon = ({ color = "#7C8AF7" }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1437 8.71084C10.9624 8.89578 10.8791 9.16324 10.9204 9.42553L11.5427 13.0506C11.5952 13.3578 11.472 13.6687 11.2277 13.8463C10.9883 14.0305 10.6699 14.0526 10.4088 13.9052L7.30891 12.2032C7.20113 12.1428 7.08144 12.1104 6.95896 12.1067H6.76928C6.70349 12.117 6.6391 12.1391 6.58031 12.173L3.47971 13.8831C3.32643 13.9642 3.15285 13.9929 2.98278 13.9642C2.56843 13.8817 2.29197 13.4661 2.35986 13.0277L2.98278 9.40269C3.02407 9.13819 2.94078 8.86926 2.75951 8.68137L0.232136 6.1026C0.0207637 5.88672 -0.0527267 5.56253 0.0438607 5.27002C0.137648 4.97825 0.377017 4.76532 0.666079 4.71743L4.14462 4.1862C4.40919 4.15746 4.64156 3.988 4.76054 3.73749L6.29334 0.429293C6.32974 0.355614 6.37663 0.287829 6.43333 0.230359L6.49632 0.178783C6.52921 0.14047 6.56701 0.108788 6.609 0.0830003L6.68529 0.0535286L6.80428 0.00195312H7.09894C7.3621 0.030688 7.59377 0.196466 7.71486 0.444029L9.26795 3.73749C9.37994 3.97842 9.59761 4.14568 9.84888 4.1862L13.3274 4.71743C13.6214 4.76164 13.8671 4.97531 13.9643 5.27002C14.056 5.56548 13.9769 5.88967 13.7614 6.1026L11.1437 8.71084Z"
        fill={color}
      />
    </svg>
  );
};

export const Lock = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.99805 0.976562C2.61755 0.976562 1.49805 2.09606 1.49805 3.47656V4.47656C0.669547 4.47656 -0.00195312 5.14806 -0.00195312 5.97656V9.47656C-0.00195312 10.3051 0.669547 10.9766 1.49805 10.9766H6.49805C7.32655 10.9766 7.99805 10.3051 7.99805 9.47656V5.97656C7.99805 5.14806 7.32655 4.47656 6.49805 4.47656V3.47656C6.49805 2.09606 5.37855 0.976562 3.99805 0.976562ZM3.99805 1.97656C4.82655 1.97656 5.49805 2.64806 5.49805 3.47656V4.47656H2.49805V3.47656C2.49805 2.64806 3.16955 1.97656 3.99805 1.97656ZM3.99805 5.97656C4.55055 5.97656 4.99805 6.42406 4.99805 6.97656C4.99805 7.33156 4.77655 7.58057 4.49805 7.75757V8.97656C4.49805 9.25256 4.27405 9.47656 3.99805 9.47656C3.72205 9.47656 3.49805 9.25256 3.49805 8.97656V7.75757C3.21955 7.58007 2.99805 7.33156 2.99805 6.97656C2.99805 6.42406 3.44555 5.97656 3.99805 5.97656Z"
        fill="#A1A1A1"
      />
    </svg>
  );
};

export const ShoulderBack = () => {
  return (
    <svg
      width="36"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.19354 11.332C7.96415 13.1233 8.37635 15.0481 8.40688 16.9979C8.40688 19.6412 7.09604 21.3962 6.35938 23.9204"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8071 11.332C18.0365 13.1233 17.6243 15.0481 17.5938 16.9979C17.5938 19.6412 18.9046 21.3962 19.6412 23.9204"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6905 2.02344C10.6877 2.75281 10.4677 3.46482 10.0587 4.06871C9.64968 4.67261 9.0701 5.14103 8.39384 5.41427L5.07884 6.7576C4.65306 6.925 4.28299 7.20885 4.01095 7.57668C3.73891 7.94451 3.57588 8.38147 3.5405 8.8376C3.37846 9.91763 3.4078 11.0177 3.62717 12.0876L4.33134 15.7926"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3047 2.02344C15.3075 2.75281 15.5275 3.46482 15.9365 4.06871C16.3455 4.67261 16.9251 5.14103 17.6014 5.41427L20.9164 6.7576C21.3421 6.925 21.7122 7.20885 21.9842 7.57668C22.2563 7.94451 22.4193 8.38147 22.4547 8.8376C22.6167 9.91763 22.5874 11.0177 22.368 12.0876L21.6639 15.7926"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 15.5547V21.1014"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ThumbsUp = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7493 4.78849L12.9615 6.24889C12.9916 6.81389 12.9667 7.38467 12.9106 7.97501L12.8874 8.2202L16.9974 8.23828C18.5301 8.23828 19.7734 9.48057 19.7734 11.0133C19.7734 11.6804 19.4811 12.3354 19.0256 12.8394L18.8855 12.9944L19.0297 13.1456C19.505 13.6438 19.7734 14.2696 19.7734 15.0133C19.7734 15.7555 19.387 16.4945 18.8248 17.0222L18.7538 17.0889V17.1863C18.7538 17.313 18.7589 17.4844 18.7637 17.6402L18.7654 17.6921C18.7697 17.8301 18.7734 17.9482 18.7734 18.0133C18.7734 18.8938 18.5514 19.5992 18.1483 20.1465C17.7448 20.6943 17.1467 21.1013 16.3648 21.3618C15.3221 21.7101 14.3686 21.7883 11.9984 21.7883C7.57041 21.7883 4.22344 18.441 4.22344 14.0133C4.22344 12.8916 4.32331 12.0223 4.56651 11.1433C4.81052 10.2613 5.20119 9.3605 5.79349 8.17592C6.32548 7.11194 6.68485 6.30466 6.90969 5.52042C7.13568 4.73218 7.22344 3.97573 7.22344 3.01328C7.22344 2.5855 7.57045 2.23828 7.99844 2.23828C9.33818 2.23828 10.3928 2.41642 11.1771 2.82189C11.9486 3.22076 12.4738 3.8474 12.7493 4.78849ZM8.73879 4.03467C8.60251 5.59369 8.15702 6.9434 7.20339 8.85065C6.6714 9.91463 6.31203 10.7219 6.08719 11.5061C5.8612 12.2944 5.77344 13.0508 5.77344 14.0133C5.77344 17.5856 8.42648 20.2383 11.9984 20.2383C13.9648 20.2383 15.2588 20.1535 16.0613 19.8418C16.4727 19.6819 16.773 19.4562 16.9652 19.1383C17.155 18.8245 17.2234 18.447 17.2234 18.0133V17.7883H15.9984C15.5704 17.7883 15.2234 17.4411 15.2234 17.0133C15.2234 16.5855 15.5704 16.2383 15.9984 16.2383H16.9984C17.3078 16.2383 17.6116 16.0613 17.8284 15.8451C18.0453 15.6287 18.2234 15.3248 18.2234 15.0133C18.2234 14.3371 17.675 13.7883 16.9984 13.7883H15.9984C15.5704 13.7883 15.2234 13.4411 15.2234 13.0133C15.2234 12.5855 15.5704 12.2383 15.9984 12.2383H16.9984C17.3098 12.2383 17.6136 12.066 17.8312 11.8494C18.0489 11.6326 18.2234 11.3287 18.2234 11.0133C18.2234 10.3371 17.675 9.78828 16.9984 9.78828H11.9984C11.9758 9.7883 11.6566 9.78852 11.3914 9.4648C11.2592 9.30304 11.227 9.16049 11.2228 9.06332C11.2193 8.98241 11.233 8.93391 11.2421 8.90129L11.2428 8.89895C11.2451 8.89078 11.2483 8.87926 11.2504 8.86856L11.253 8.85565L11.4113 6.34514C11.389 5.93133 11.3367 5.54446 11.2457 5.23148C11.1259 4.81938 10.8875 4.47896 10.5026 4.23672C10.1237 3.9983 9.618 3.86429 8.97506 3.82959L8.75775 3.81787L8.73879 4.03467Z"
        fill="black"
      />
    </svg>
  );
};

export const YogaStretching = () => {
  return (
    <svg
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 9.52344C10.2426 9.52344 11.25 8.51608 11.25 7.27344C11.25 6.0308 10.2426 5.02344 9 5.02344C7.75736 5.02344 6.75 6.0308 6.75 7.27344C6.75 8.51608 7.75736 9.52344 9 9.52344Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.365 23.0161L12.75 19.4001V14.5641C13.5175 14.1917 14.2207 13.6992 14.833 13.1051C16.3805 11.5584 17.25 9.4601 17.25 7.27213C17.25 5.08416 16.3805 2.98586 14.833 1.43913C14.247 0.853429 13.2972 0.853653 12.7115 1.43963C12.1258 2.0256 12.126 2.97543 12.712 3.56113C13.6968 4.54524 14.2501 5.88039 14.2501 7.27263C14.2501 8.66486 13.6968 10 12.712 10.9841C10.635 12.9681 7.36499 12.9681 5.28798 10.9841C4.30318 10 3.74986 8.66486 3.74986 7.27263C3.74986 5.88039 4.30318 4.54524 5.28798 3.56113C5.87396 2.97543 5.87418 2.0256 5.28848 1.43963C4.70278 0.853653 3.75296 0.853429 3.16698 1.43913C1.61946 2.98586 0.75 5.08416 0.75 7.27213C0.75 9.4601 1.61946 11.5584 3.16698 13.1051C3.77927 13.6992 4.48245 14.1917 5.24998 14.5641V23.0221"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1188 23.0113L10.8188 21.7053C10.3898 21.2761 9.74439 21.1476 9.1837 21.3799C8.623 21.6122 8.25754 22.1594 8.25781 22.7663V23.0233"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Salad = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.25 14.125C24.25 19.096 19.214 23.125 13 23.125C6.786 23.125 1.75 19.1 1.75 14.125H24.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.741 11.125C9.25367 10.2357 8.57335 9.46692 7.75 8.875"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1734 7.85214C13.3532 6.75982 12.9168 5.65727 12.0381 4.98387C11.1595 4.31046 9.98144 4.17564 8.97339 4.63314C8.28773 3.1243 6.50873 2.45698 4.99989 3.14264C3.49105 3.8283 2.82373 5.6073 3.50939 7.11614C2.00121 7.80163 1.33416 9.57984 2.01939 11.0881L2.03639 11.1241"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6752 11.1232C22.9777 9.63324 22.3507 8.10806 21.0877 7.26171C19.8247 6.41537 18.1757 6.41537 16.9126 7.26171C15.6496 8.10806 15.0226 9.63324 15.3252 11.1232"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Target = ({isWalky}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0.746094V23.2461"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.25 11.9961H0.75"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20.9961C16.9706 20.9961 21 16.9667 21 11.9961C21 7.02553 16.9706 2.99609 12 2.99609C7.02944 2.99609 3 7.02553 3 11.9961C3 16.9667 7.02944 20.9961 12 20.9961Z"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16.4961C14.4853 16.4961 16.5 14.4814 16.5 11.9961C16.5 9.51081 14.4853 7.49609 12 7.49609C9.51472 7.49609 7.5 9.51081 7.5 11.9961C7.5 14.4814 9.51472 16.4961 12 16.4961Z"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Scale2 = ({isWalky}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6008 1.80078H5.40078C3.41256 1.80078 1.80078 3.41256 1.80078 5.40078V18.6008C1.80078 20.589 3.41256 22.2008 5.40078 22.2008H18.6008C20.589 22.2008 22.2008 20.589 22.2008 18.6008V5.40078C22.2008 3.41256 20.589 1.80078 18.6008 1.80078Z"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8064 10.4627C15.6675 10.5585 16.5214 10.7108 17.3624 10.9187L18.5984 5.99874C14.251 5.03688 9.74587 5.03688 5.39844 5.99874L6.59844 10.8827C8.37287 10.5008 10.1834 10.3117 11.9984 10.3187L13.6904 7.70274"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Garant = () => {
  return (
    <svg
      width="27"
      height="33"
      viewBox="0 0 27 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3906 32.0156C13.2552 32.0156 13.0885 31.9844 12.8906 31.9219C12.7031 31.8698 12.5052 31.7917 12.2969 31.6875C10.0573 30.4583 8.16146 29.3542 6.60938 28.375C5.06771 27.4062 3.82292 26.4635 2.875 25.5469C1.9375 24.6302 1.25521 23.6406 0.828125 22.5781C0.411458 21.5052 0.203125 20.2552 0.203125 18.8281V7.01562C0.203125 6.08854 0.385417 5.41146 0.75 4.98438C1.125 4.54688 1.69792 4.16667 2.46875 3.84375C2.8125 3.69792 3.29688 3.50521 3.92188 3.26562C4.54688 3.02604 5.23958 2.77083 6 2.5C6.76042 2.21875 7.51562 1.94271 8.26562 1.67188C9.01562 1.40104 9.69792 1.16146 10.3125 0.953125C10.9375 0.734375 11.4219 0.578125 11.7656 0.484375C12.026 0.421875 12.2969 0.364583 12.5781 0.3125C12.8594 0.25 13.1302 0.21875 13.3906 0.21875C13.6615 0.21875 13.9375 0.244792 14.2188 0.296875C14.5104 0.348958 14.7812 0.411458 15.0312 0.484375C15.375 0.598958 15.8542 0.765625 16.4688 0.984375C17.0938 1.20312 17.7812 1.44792 18.5312 1.71875C19.2917 1.97917 20.0469 2.24479 20.7969 2.51562C21.5573 2.78646 22.25 3.04167 22.875 3.28125C23.5 3.51042 23.9844 3.69792 24.3281 3.84375C25.1094 4.17708 25.6823 4.55729 26.0469 4.98438C26.4115 5.41146 26.5938 6.08854 26.5938 7.01562V18.8281C26.5938 20.2552 26.3854 21.5052 25.9688 22.5781C25.5521 23.6406 24.8698 24.6354 23.9219 25.5625C22.9844 26.4792 21.7396 27.4219 20.1875 28.3906C18.6458 29.3594 16.75 30.4583 14.5 31.6875C14.2917 31.7917 14.0885 31.8698 13.8906 31.9219C13.7031 31.9844 13.5365 32.0156 13.3906 32.0156ZM13.3906 28.7188C13.5052 28.7188 13.6302 28.6927 13.7656 28.6406C13.901 28.5885 14.0781 28.4948 14.2969 28.3594C16.0573 27.2969 17.5365 26.3854 18.7344 25.625C19.9427 24.8542 20.9062 24.125 21.625 23.4375C22.3542 22.75 22.875 22.0052 23.1875 21.2031C23.5 20.3906 23.6562 19.4062 23.6562 18.25V7.51562C23.6562 7.24479 23.6198 7.04167 23.5469 6.90625C23.474 6.76042 23.3333 6.65104 23.125 6.57812C22.6458 6.41146 22.099 6.21875 21.4844 6C20.8802 5.78125 20.2396 5.55208 19.5625 5.3125C18.8958 5.07292 18.2344 4.83333 17.5781 4.59375C16.9219 4.35417 16.3021 4.13021 15.7188 3.92188C15.1354 3.70312 14.6354 3.51042 14.2188 3.34375C14.0417 3.28125 13.8854 3.23438 13.75 3.20312C13.625 3.17188 13.5052 3.15625 13.3906 3.15625C13.2865 3.15625 13.1667 3.17188 13.0312 3.20312C12.9062 3.23438 12.7552 3.28125 12.5781 3.34375C12.1615 3.51042 11.6615 3.69792 11.0781 3.90625C10.4948 4.11458 9.86979 4.33333 9.20312 4.5625C8.54688 4.79167 7.88021 5.02604 7.20312 5.26562C6.53646 5.50521 5.89583 5.73958 5.28125 5.96875C4.67708 6.1875 4.14583 6.39062 3.6875 6.57812C3.46875 6.66146 3.32292 6.77083 3.25 6.90625C3.17708 7.04167 3.14062 7.24479 3.14062 7.51562V18.25C3.14062 19.3958 3.29688 20.3698 3.60938 21.1719C3.92188 21.974 4.43229 22.7188 5.14062 23.4062C5.85938 24.0833 6.81771 24.8073 8.01562 25.5781C9.22396 26.349 10.7188 27.276 12.5 28.3594C12.7188 28.4948 12.8958 28.5885 13.0312 28.6406C13.1667 28.6927 13.2865 28.7188 13.3906 28.7188ZM11.7344 22.7031C11.4427 22.7031 11.1823 22.6406 10.9531 22.5156C10.724 22.3802 10.5 22.1823 10.2812 21.9219L6.59375 17.4219C6.32292 17.0781 6.1875 16.7292 6.1875 16.375C6.1875 15.9896 6.31771 15.6615 6.57812 15.3906C6.84896 15.1094 7.17188 14.9688 7.54688 14.9688C7.78646 14.9688 8 15.0208 8.1875 15.125C8.38542 15.2188 8.57812 15.3906 8.76562 15.6406L11.6719 19.3281L17.8438 9.4375C18.1667 8.90625 18.5729 8.64062 19.0625 8.64062C19.4271 8.64062 19.7552 8.76042 20.0469 9C20.3385 9.23958 20.4844 9.55208 20.4844 9.9375C20.4844 10.1146 20.4427 10.2969 20.3594 10.4844C20.2865 10.6615 20.1979 10.8281 20.0938 10.9844L13.1094 21.9062C12.776 22.4375 12.3177 22.7031 11.7344 22.7031Z"
        fill="#058D66"
      />
    </svg>
  );
};

export const Calendar = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M8.00586 2.01416C7.45386 2.01416 7.00586 2.46216 7.00586 3.01416C4.79686 3.01416 3.00586 4.80516 3.00586 7.01416V9.01416V17.0142C3.00586 19.2222 4.79686 21.0142 7.00586 21.0142H17.0059C19.2149 21.0142 21.0059 19.2232 21.0059 17.0142V9.01416V7.01416C21.0059 4.80516 19.2149 3.01416 17.0059 3.01416C17.0059 2.46216 16.5579 2.01416 16.0059 2.01416C15.4539 2.01416 15.0059 2.46216 15.0059 3.01416H9.00586C9.00586 2.46216 8.55786 2.01416 8.00586 2.01416ZM7.00586 5.01416C7.00586 5.56616 7.45386 6.01416 8.00586 6.01416C8.55786 6.01416 9.00586 5.56616 9.00586 5.01416H15.0059C15.0059 5.56616 15.4539 6.01416 16.0059 6.01416C16.5579 6.01416 17.0059 5.56616 17.0059 5.01416C18.1109 5.01416 19.0059 5.90916 19.0059 7.01416V8.01416C17.0819 8.01416 6.92986 8.01416 5.00586 8.01416V7.01416C5.00586 5.90916 5.90086 5.01416 7.00586 5.01416ZM5.00586 10.0142C6.92986 10.0142 17.0819 10.0142 19.0059 10.0142V17.0142C19.0059 18.1172 18.1109 19.0142 17.0059 19.0142H7.00586C5.90086 19.0142 5.00586 18.1192 5.00586 17.0142V10.0142ZM15.0059 12.0142C14.4539 12.0142 14.0059 12.4622 14.0059 13.0142V14.0142C14.0059 14.5662 14.4539 15.0142 15.0059 15.0142H16.0059C16.5579 15.0142 17.0059 14.5662 17.0059 14.0142V13.0142C17.0059 12.4622 16.5579 12.0142 16.0059 12.0142H15.0059Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

export const Performance = () => {
  return (
    <svg
      width="21"
      height="14"
      viewBox="0 0 21 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6555 7.43329C20.201 7.43851 20.6475 7.88496 20.6527 8.43047L20.6908 12.3814C20.6933 12.6434 20.5916 12.8936 20.4082 13.0771C20.2247 13.2605 19.9745 13.3622 19.7125 13.3597L15.7615 13.3218C15.2159 13.3165 14.7695 12.8701 14.7642 12.3246C14.759 11.7791 15.197 11.3411 15.7425 11.3463L17.2846 11.3611L10.7029 4.87105L7.46976 7.69266C7.08172 8.03133 6.49173 8.00604 6.1205 7.63484L1.13409 2.64879C0.744643 2.25937 0.73862 1.63397 1.12064 1.25192C1.50266 0.869874 2.12805 0.875851 2.5175 1.26527L6.84422 5.59168L10.0724 2.77434C10.4584 2.43744 11.0448 2.46048 11.4166 2.82717L18.6926 10.0017L18.6773 8.41158C18.672 7.86607 19.11 7.42808 19.6555 7.43329Z"
        fill="#058D66"
      />
    </svg>
  );
};

export const Rewards = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 0C3.94772 0 3.5 0.447715 3.5 1V2H1.5C0.947715 2 0.5 2.44772 0.5 3V6C0.5 8.09706 2.11375 9.8172 4.16716 9.98635C5.15183 12.0708 7.13529 13.5909 9.5 13.9291V18H7.5C6.94771 18 6.5 18.4477 6.5 19C6.5 19.5523 6.94771 20 7.5 20H13.5C14.0523 20 14.5 19.5523 14.5 19C14.5 18.4477 14.0523 18 13.5 18H11.5V13.9291C13.8647 13.5909 15.8482 12.0708 16.8328 9.98635C18.8863 9.8172 20.5 8.09706 20.5 6V3C20.5 2.44772 20.0523 2 19.5 2H17.5V1C17.5 0.447715 17.0523 0 16.5 0H4.5ZM2.5 4H3.5V7C3.5 7.25512 3.51365 7.50705 3.54025 7.7551C2.92032 7.41538 2.5 6.75678 2.5 6V4ZM15.5 3V2H5.5V3V7C5.5 9.76142 7.73858 12 10.5 12C13.2614 12 15.5 9.76142 15.5 7V3ZM17.5 4H18.5V6C18.5 6.75678 18.0797 7.41538 17.4597 7.7551C17.4864 7.50705 17.5 7.25512 17.5 7V4ZM10.5 4C9.39543 4 8.5 4.89543 8.5 6C8.5 7.10457 9.39543 8 10.5 8C11.6046 8 12.5 7.10457 12.5 6C12.5 4.89543 11.6046 4 10.5 4Z"
        fill="#058D66"
      />
    </svg>
  );
};

export const Like = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8233 19.8806L12.5041 18L13.2095 19.8716C12.7632 20.0396 12.2717 20.0428 11.8233 19.8806ZM11.0473 7.12301C10.2677 6.54309 9.23685 6 8.11058 6C5.58431 6 4.1015 8 4.59577 10.7452C5.44201 15.4452 12.5041 18 12.5041 18C11.8233 19.8806 11.8227 19.8804 11.8222 19.8802L11.8179 19.8787L11.81 19.8758L11.7864 19.8671C11.7673 19.86 11.7417 19.8503 11.7097 19.8381C11.6459 19.8137 11.557 19.779 11.4464 19.7342C11.2255 19.6445 10.9164 19.5135 10.5459 19.3419C9.80917 19.0004 8.80921 18.4885 7.77044 17.8078C5.80218 16.5181 3.20372 14.3044 2.62668 11.0995C2.3045 9.31009 2.59062 7.53226 3.6127 6.15279C4.65683 4.74354 6.28769 4 8.11058 4C9.98141 4 11.5178 4.946 12.449 5.67693C12.4675 5.69144 12.4859 5.70595 12.5041 5.72045C12.5223 5.70595 12.5407 5.69144 12.5592 5.67693C13.4905 4.946 15.0268 4 16.8976 4C21.0053 4 23.0663 7.99583 22.3664 11.175C21.6786 14.2994 19.1305 16.4889 17.1823 17.7859C16.1589 18.4672 15.1793 18.9822 14.458 19.3268C14.0955 19.4999 13.7935 19.6323 13.5776 19.7231C13.4696 19.7685 13.3828 19.8036 13.3205 19.8284C13.2893 19.8408 13.2642 19.8506 13.2456 19.8578L13.2225 19.8666L13.2147 19.8696L13.2105 19.8712C13.21 19.8714 13.2095 19.8716 12.5041 18C12.5041 18 19.3859 15.4083 20.4124 10.7452C20.9067 8.5 19.4239 6 16.8976 6C15.7714 6 14.7405 6.54309 13.9609 7.12301C13.0677 7.78734 12.5041 8.5 12.5041 8.5C12.5041 8.5 11.9405 7.78734 11.0473 7.12301Z"
        fill="#058D66"
      />
    </svg>
  );
};

export const Lock2 = ({ className }) => {
  return (
    <svg
      className={className}
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={className}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.49726 16C1.17397 16 0.5 15.3509 0.5 13.9824V8.17204C0.5 6.95992 1.05068 6.31085 2.11918 6.19355L4.07534 6.17009H8.9411V4.30108C8.9411 2.71359 7.84795 1.79081 6.5 1.79081C5.49341 1.79081 4.63807 2.3054 4.26941 3.2271C4.09276 3.66875 3.68474 4.03053 3.21269 3.97197C2.61965 3.89841 2.17772 3.35675 2.36822 2.79034C2.97103 0.997971 4.59992 0 6.5 0C8.90822 0 10.889 1.60313 10.889 4.39492V6.19355C11.9575 6.31085 12.5 6.95992 12.5 8.17204V13.9824C12.5 15.3509 11.826 16 10.511 16H2.49726ZM8.00228 10.2487C8.00228 10.805 7.69996 11.2907 7.25065 11.5505V12.5026C7.25065 12.9175 6.91428 13.2539 6.49935 13.2539C6.08442 13.2539 5.74805 12.9175 5.74805 12.5026V11.5501C5.2991 11.2902 4.99707 10.8047 4.99707 10.2487C4.99707 9.41883 5.66981 8.74609 6.49967 8.74609C7.32954 8.74609 8.00228 9.41883 8.00228 10.2487Z"
        fill="white"
      />
    </svg>
  );
};

export const Dumbbell = ({isWalky}) => {
  return (
    <svg
      width="25"
      height="15"
      viewBox="0 0 25 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 7.5H16.25"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 13.5C6.42157 13.5 5.75 12.8284 5.75 12V3C5.75 2.17157 6.42157 1.5 7.25 1.5C8.07843 1.5 8.75 2.17157 8.75 3V12C8.75 12.8284 8.07843 13.5 7.25 13.5Z"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.75 7.5H1.25"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 4.5C3.42157 4.5 2.75 5.17157 2.75 6V9C2.75 9.82843 3.42157 10.5 4.25 10.5C5.07843 10.5 5.75 9.82843 5.75 9V6C5.75 5.17157 5.07843 4.5 4.25 4.5Z"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.75 13.5C18.5784 13.5 19.25 12.8284 19.25 12V3C19.25 2.17157 18.5784 1.5 17.75 1.5C16.9216 1.5 16.25 2.17157 16.25 3V12C16.25 12.8284 16.9216 13.5 17.75 13.5Z"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.25 7.5H23.75"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.75 4.5C21.5784 4.5 22.25 5.17157 22.25 6V9C22.25 9.82843 21.5784 10.5 20.75 10.5C19.9216 10.5 19.25 9.82843 19.25 9V6C19.25 5.17157 19.9216 4.5 20.75 4.5Z"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Body = ({isWalky}) => {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.084 1.6875C0.73925 3.03225 0.951917 5.994 2.9805 7.51658C4.77442 8.86133 5.67092 9.75783 5.67092 13.3448C5.67092 16.9317 1.1875 19.1738 1.1875 22.3125"
         stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.916 1.6875C22.2608 3.03225 22.0481 5.99583 20.0195 7.51658C18.2256 8.86133 17.3291 9.75783 17.3291 13.3448C17.3291 16.9317 21.8125 19.1738 21.8125 22.3125"
         stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4985 8.85769C15.1068 8.93835 14.7273 7.5166 11.4997 7.5166C8.27214 7.5166 7.88989 8.93835 4.50098 8.85769"
         stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.98047 18.7256C5.22264 18.7256 8.3613 20.5195 11.5 20.5195C14.6386 20.5195 17.7773 18.7256 20.0195 18.7256"
         stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.70703 1.6875C10.6035 1.6875 11.5 3.03225 11.5 3.03225C11.7664 2.25948 12.4766 1.72686 13.293 1.6875"
         stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 16.8125C11.6898 16.8125 11.8438 16.9664 11.8438 17.1562"
         stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1562 17.1562C11.1562 16.9664 11.3102 16.8125 11.5 16.8125"
         stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 17.5C11.3102 17.5 11.1562 17.3461 11.1562 17.1562"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8438 17.1562C11.8438 17.3461 11.6898 17.5 11.5 17.5"
        stroke={isWalky ? "#E7394F" : "#7C8AF7"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckOutlined = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99805 0.953125C8.63915 0.953125 7.43175 1.50714 6.50085 2.48114C5.20965 2.47614 3.85725 2.90613 2.90425 3.85913C1.95135 4.81213 1.48455 6.18714 1.53725 7.43414C0.563847 8.36514 -0.00195312 9.59412 -0.00195312 10.9531C-0.00195312 12.3121 0.572248 13.5561 1.54555 14.4871C1.51505 15.8411 1.95135 17.0941 2.90425 18.0471C3.85735 19.0001 5.11685 19.4091 6.47195 19.4221C7.40295 20.3951 8.63915 20.9531 9.99805 20.9531C11.3569 20.9531 12.5761 20.4011 13.507 19.4281C14.8195 19.4231 16.1389 19.0001 17.0919 18.0471C18.0448 17.0941 18.4975 15.7672 18.4588 14.4832C19.4321 13.5522 19.998 12.3121 19.998 10.9531C19.998 9.59412 19.43 8.37613 18.4566 7.44513C18.4872 6.09113 18.0448 4.81213 17.0919 3.85913C16.1388 2.90613 14.7639 2.4411 13.5182 2.4881C12.5873 1.5151 11.3568 0.953125 9.99805 0.953125ZM9.99805 2.95312C10.8963 2.95312 11.7195 3.38911 12.3105 4.14111C12.5246 4.41311 12.873 4.55414 13.2169 4.51514C14.181 4.40714 15.0362 4.67912 15.6542 5.29712C16.2722 5.91512 16.5439 6.77013 16.4355 7.73413C16.3968 8.07813 16.5385 8.42611 16.8105 8.64111C17.5616 9.23211 17.998 10.0551 17.998 10.9531C17.998 11.8511 17.5616 12.6741 16.8105 13.2651C16.5385 13.4801 16.3968 13.8281 16.4355 14.1721C16.5439 15.1361 16.2722 15.9911 15.6542 16.6091C15.0363 17.2271 14.181 17.4991 13.2169 17.3911C12.8729 17.3521 12.5245 17.4931 12.3105 17.7651C11.7195 18.5171 10.8963 18.9531 9.99805 18.9531C9.09975 18.9531 8.27665 18.5171 7.68555 17.7651C7.47145 17.4931 7.12315 17.3521 6.77925 17.3911C5.81515 17.4991 4.95975 17.2271 4.34185 16.6091C3.72385 15.9911 3.45225 15.1361 3.56055 14.1721C3.59925 13.8281 3.45755 13.4801 3.18555 13.2651C2.43445 12.6741 1.99805 11.8511 1.99805 10.9531C1.99805 10.0551 2.43445 9.23211 3.18555 8.64111C3.45755 8.42611 3.59925 8.07813 3.56055 7.73413C3.45215 6.77013 3.72385 5.91512 4.34185 5.29712C4.95975 4.67912 5.81515 4.40714 6.77925 4.51514C7.12325 4.55414 7.47155 4.41311 7.68555 4.14111C8.27655 3.38911 9.09975 2.95312 9.99805 2.95312ZM12.998 7.95312C12.7421 7.95312 12.4745 8.03913 12.2792 8.23413L8.99805 11.5151L7.71685 10.2341C7.32625 9.84413 6.66985 9.84413 6.27925 10.2341C5.88875 10.6251 5.88875 11.2811 6.27925 11.6721L8.27925 13.6721C8.66985 14.0621 9.32625 14.0621 9.71685 13.6721L13.7169 9.67212C14.1074 9.28112 14.1074 8.62513 13.7169 8.23413C13.5216 8.03913 13.254 7.95312 12.998 7.95312Z"
        fill="#058D66"
      />
    </svg>
  );
};

export const ErrorOutlined = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99805 0.953125C8.63905 0.953125 7.42905 1.51113 6.49805 2.48413C5.20705 2.48013 3.85705 2.90613 2.90405 3.85913C1.95105 4.81213 1.47705 6.17512 1.52905 7.42212C0.556053 8.35312 -0.00195312 9.59412 -0.00195312 10.9531C-0.00195312 12.3121 0.587043 13.5531 1.56004 14.4841C1.53004 15.8391 1.95105 17.0941 2.90405 18.0471C3.85705 19.0001 5.11204 19.4091 6.46704 19.4221C7.39804 20.3951 8.63905 20.9531 9.99805 20.9531C11.357 20.9531 12.567 20.3951 13.498 19.4221C14.811 19.4171 16.139 19.0001 17.092 18.0471C18.045 17.0941 18.506 15.7681 18.467 14.4841C19.44 13.5531 19.998 12.3121 19.998 10.9531C19.998 9.59412 19.44 8.38412 18.467 7.45312C18.497 6.09912 18.045 4.81213 17.092 3.85913C16.139 2.90613 14.7751 2.43713 13.5291 2.48413C12.5981 1.51113 11.357 0.953125 9.99805 0.953125ZM9.99805 2.95312C10.896 2.95312 11.719 3.38911 12.31 4.14111C12.525 4.41311 12.873 4.55414 13.217 4.51514C14.181 4.40714 15.0361 4.67912 15.6541 5.29712C16.2721 5.91512 16.5441 6.77013 16.4361 7.73413C16.3971 8.07813 16.539 8.42611 16.81 8.64111C17.562 9.23211 17.998 10.0551 17.998 10.9531C17.998 11.8511 17.562 12.6741 16.81 13.2651C16.538 13.4801 16.3971 13.8281 16.4361 14.1721C16.5441 15.1361 16.2721 15.9911 15.6541 16.6091C15.0361 17.2271 14.181 17.4991 13.217 17.3911C12.873 17.3521 12.525 17.4931 12.31 17.7651C11.719 18.5171 10.896 18.9531 9.99805 18.9531C9.10005 18.9531 8.27705 18.5171 7.68605 17.7651C7.47105 17.4931 7.12305 17.3521 6.77905 17.3911C5.81505 17.4991 4.96004 17.2271 4.34204 16.6091C3.72404 15.9911 3.45204 15.1361 3.56004 14.1721C3.59904 13.8281 3.45705 13.4801 3.18605 13.2651C2.43405 12.6741 1.99805 11.8511 1.99805 10.9531C1.99805 10.0551 2.43405 9.23211 3.18605 8.64111C3.45805 8.42611 3.59904 8.07813 3.56004 7.73413C3.45204 6.77013 3.72404 5.91512 4.34204 5.29712C4.96004 4.67912 5.81505 4.40714 6.77905 4.51514C7.12305 4.55414 7.47105 4.41311 7.68605 4.14111C8.27705 3.38911 9.10005 2.95312 9.99805 2.95312ZM9.99805 5.95312C9.44605 5.95312 8.99805 6.40112 8.99805 6.95312V11.9531C8.99805 12.5051 9.44605 12.9531 9.99805 12.9531C10.55 12.9531 10.998 12.5051 10.998 11.9531V6.95312C10.998 6.40112 10.55 5.95312 9.99805 5.95312ZM9.99805 13.9531C9.44605 13.9531 8.99805 14.4011 8.99805 14.9531C8.99805 15.5051 9.44605 15.9531 9.99805 15.9531C10.55 15.9531 10.998 15.5051 10.998 14.9531C10.998 14.4011 10.55 13.9531 9.99805 13.9531Z"
        fill="#FF4F64"
        fillOpacity="0.5"
      />
    </svg>
  );
};

export const KeyboardArrow = () => {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.60247 0.851737C0.96045 0.493757 1.54085 0.493757 1.89883 0.851737L7.39883 6.35174C7.75681 6.70972 7.75681 7.29012 7.39883 7.6481L1.89883 13.1481C1.54085 13.5061 0.96045 13.5061 0.60247 13.1481C0.244489 12.7901 0.244489 12.2097 0.60247 11.8517L5.45429 6.99992L0.60247 2.1481C0.244489 1.79012 0.244489 1.20972 0.60247 0.851737Z"
        fill="white"
      />
    </svg>
  );
};
export const GrayKeyboardArrow = () => {
  return (
    <svg
      width="6"
      height="12"
      viewBox="0 0 6 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.21967 0.96967C0.512563 0.676777 0.987437 0.676777 1.28033 0.96967L5.78033 5.46967C6.07322 5.76256 6.07322 6.23744 5.78033 6.53033L1.28033 11.0303C0.987437 11.3232 0.512563 11.3232 0.21967 11.0303C-0.0732233 10.7374 -0.0732233 10.2626 0.21967 9.96967L4.18934 6L0.21967 2.03033C-0.0732233 1.73744 -0.0732233 1.26256 0.21967 0.96967Z"
        fill="#9396A6"
      />
    </svg>
  );
};

export const Clock = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.01042 0.33252C3.32855 0.33252 0.34375 3.31719 0.34375 6.99919C0.34375 10.6812 3.32855 13.6659 7.01042 13.6659C10.6923 13.6659 13.6771 10.6812 13.6771 6.99919C13.6771 3.31719 10.6923 0.33252 7.01042 0.33252ZM7.01042 2.99919C7.37862 2.99919 7.67708 3.29785 7.67708 3.66585V6.70719L9.48962 8.51986C9.74995 8.78052 9.74995 9.21785 9.48962 9.47851C9.22922 9.73851 8.79161 9.73851 8.53121 9.47851L6.53122 7.47852C6.40622 7.35318 6.34375 7.17585 6.34375 6.99919V3.66585C6.34375 3.29785 6.64222 2.99919 7.01042 2.99919Z"
        fill="white"
      />
    </svg>
  );
};

export const Done = () => {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4.5L4 6.5L8 1.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Share = ({ color = "black" }) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.49072 19.9954C2.28172 19.9954 0.490723 18.2044 0.490723 15.9954V11.9954C0.490723 9.78639 2.28172 7.99539 4.49072 7.99539C5.04272 7.99539 5.49072 8.44338 5.49072 8.99539C5.49072 9.54739 5.04272 9.99539 4.49072 9.99539C3.38572 9.99539 2.49072 10.8904 2.49072 11.9954V15.9954C2.49072 17.1004 3.38572 17.9954 4.49072 17.9954H14.4907C15.5957 17.9954 16.4907 17.1004 16.4907 15.9954V11.9954C16.4907 10.8904 15.5957 9.99539 14.4907 9.99539C13.9387 9.99539 13.4907 9.54739 13.4907 8.99539C13.4907 8.44338 13.9387 7.99539 14.4907 7.99539C16.6997 7.99539 18.4907 9.78639 18.4907 11.9954V15.9954C18.4907 18.2044 16.6997 19.9954 14.4907 19.9954H4.49072ZM9.49072 12.9954C8.93872 12.9954 8.49072 12.5474 8.49072 11.9954V4.43339L6.49072 6.40139L5.08472 4.99538L8.77173 1.27639C9.16273 0.886387 9.81872 0.886387 10.2097 1.27639L13.8967 4.99538L12.4907 6.40139L10.4907 4.43339V11.9954C10.4907 12.5474 10.0427 12.9954 9.49072 12.9954Z"
        fill={color}
      />
    </svg>
  );
};

export const Login = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0141602 8.99072C0.0141602 8.43872 0.46186 7.99072 1.01416 7.99072H10.0142V4.99072L14.0142 8.99072L10.0142 12.9907V9.99072H1.01416C0.46186 9.99072 0.0140602 9.54272 0.0141602 8.99072ZM3.01416 3.99072C3.01416 1.78172 4.80506 -0.00927734 7.01416 -0.00927734H15.0142C17.2233 -0.00927734 19.0142 1.78172 19.0142 3.99072V13.9907C19.0142 16.1997 17.2233 17.9907 15.0142 17.9907H7.01416C4.80506 17.9907 3.01416 16.1997 3.01416 13.9907C3.01416 13.4387 3.46186 12.9907 4.01416 12.9907C4.56646 12.9907 5.01416 13.4387 5.01416 13.9907C5.01416 15.0957 5.90956 15.9907 7.01416 15.9907H15.0142C16.1188 15.9907 17.0142 15.0957 17.0142 13.9907V3.99072C17.0142 2.88572 16.1188 1.99072 15.0142 1.99072H7.01416C5.90956 1.99072 5.01416 2.88572 5.01416 3.99072C5.01416 4.54272 4.56646 4.99072 4.01416 4.99072C3.46186 4.99072 3.01416 4.54272 3.01416 3.99072Z"
        fill="black"
      />
    </svg>
  );
};

export const RightArrow = () => {
  return (
    <svg
      width="21"
      height="12"
      viewBox="0 0 21 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0140991 5.9848C0.0140991 5.4338 0.461101 4.98779 1.0121 4.98779L16.5761 4.9978L13.6081 1.9978L15.0141 0.591797L19.7331 5.27881C20.1231 5.66981 20.1231 6.3258 19.7331 6.7168L15.0141 11.4038L13.6081 9.9978L16.5761 6.9978L1.0121 6.98279C0.461101 6.98279 0.0140991 6.5358 0.0140991 5.9848Z"
        fill="white"
      />
    </svg>
  );
};

export const PriceArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
    >
      <path
        d="M0.507812 3.99325C0.507812 3.62525 0.806013 3.32725 1.17381 3.32725C1.49235 3.32725 5.21715 3.32725 6.21048 3.32725L4.23314 1.32924L5.16981 0.392578L8.31248 3.51459C8.44315 3.64459 8.50781 3.81925 8.50781 3.99392C8.50781 4.16792 8.44248 4.34192 8.31248 4.47192L5.16981 7.59391L4.23314 6.65725L6.21048 4.65924C5.21715 4.65924 1.49235 4.65924 1.17381 4.65924C0.806013 4.65924 0.507812 4.36125 0.507812 3.99325Z"
        fill="black"
      />
    </svg>
  );
};
